// import React, { useState, useEffect } from 'react';
// import { database, ref, get, set, update } from '../../firebase';
// import { Wallet, Send, Loader2, Check, Copy, Calendar, Clock, CreditCard, Lock, Package, AlertCircle, Shield, XCircle, Zap, TrendingUp, Battery } from 'lucide-react';

// // Dialog Component (keep as is)
// const Dialog = ({ isOpen, onClose, title, message, type = 'success' }) => {
//   if (!isOpen) return null;

//   const getIcon = () => {
//     switch(type) {
//       case 'error': return <XCircle className="text-red-400" size={40} />;
//       case 'warning': return <AlertCircle className="text-yellow-400" size={40} />;
//       default: return <Check className="text-green-400" size={40} />;
//     }
//   };

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
//       <div 
//         className="absolute inset-0 bg-black/70 backdrop-blur-sm"
//         onClick={onClose}
//       />
      
//       <div className="relative z-10 w-full max-w-sm bg-gray-900 border border-gray-700 rounded-xl p-6 shadow-2xl">
//         <button
//           onClick={onClose}
//           className="absolute right-3 top-3 text-gray-400 hover:text-white"
//         >
//           ✕
//         </button>

//         <div className="text-center">
//           <div className="flex justify-center mb-4">
//             {getIcon()}
//           </div>
          
//           <h3 className="text-xl font-bold text-white mb-3">
//             {title}
//           </h3>
          
//           <div className="text-gray-200 text-sm mb-6 whitespace-pre-line">
//             {message}
//           </div>
          
//           <button
//             onClick={onClose}
//             className={`px-6 py-2 rounded-lg font-medium text-sm ${
//               type === 'success' 
//                 ? 'bg-blue-600 hover:bg-blue-700 text-white' 
//                 : type === 'error'
//                 ? 'bg-red-600 hover:bg-red-700 text-white'
//                 : 'bg-yellow-600 hover:bg-yellow-700 text-white'
//             }`}
//           >
//             OK
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// const RequestWithdrawal = () => {
//   // User states
//   const [workingBalance, setWorkingBalance] = useState(0);
//   const [roiBalance, setRoiBalance] = useState(0);
//   const [energyBalance, setEnergyBalance] = useState(0);
//   const [userId, setUserId] = useState('');
//   const [userDbKey, setUserDbKey] = useState('');
//   const [userRegistrationDate, setUserRegistrationDate] = useState('');
//   const [userWithdrawalStatus, setUserWithdrawalStatus] = useState('active');
//   const [loading, setLoading] = useState(false);
//   const [withdrawalType, setWithdrawalType] = useState('working');
//   const [userCountry, setUserCountry] = useState('');
//   const [userCity, setUserCity] = useState('');
//   const [userTimeZoneHint, setUserTimeZoneHint] = useState('');
  
//   // Dialog states
//   const [dialog, setDialog] = useState({
//     isOpen: false,
//     title: '',
//     message: '',
//     type: 'success'
//   });
  
//   // Withdrawal conditions (stored in GST)
//   const [withdrawalConditions, setWithdrawalConditions] = useState({
//     minWithdrawal: 12,
//     agPower: { days: ['Everyday'], startTime1: '00:00', endTime1: '03:00', slot1Enabled: true, startTime2: '12:00', endTime2: '15:00', slot2Enabled: true },
//     agRoi: { days: ['Wednesday'], startTime1: '00:00', endTime1: '03:00', slot1Enabled: true, startTime2: '12:00', endTime2: '15:00', slot2Enabled: true },
//     agEnergy: { days: ['Saturday'], startTime1: '00:00', endTime1: '03:00', slot1Enabled: true, startTime2: '12:00', endTime2: '15:00', slot2Enabled: true }
//   });
  
//   // Daily withdrawal limit
//   const [dailyWithdrawalCount, setDailyWithdrawalCount] = useState(0);
//   const [maxDailyWithdrawals] = useState(1);
  
//   // Cryptocurrency
//   const [availableCurrencies] = useState(['USDT-TRC20', 'USDT-BEP20']);
//   const [usedCurrenciesData, setUsedCurrenciesData] = useState({});
//   const [selectedCrypto, setSelectedCrypto] = useState('');
//   const [amount, setAmount] = useState('');
//   const [cryptoAddress, setCryptoAddress] = useState('');
  
//   // Packages and fee
//   const [userPackages, setUserPackages] = useState([]);
//   const [packagesData, setPackagesData] = useState({});
//   const [withdrawalFee, setWithdrawalFee] = useState(10);
//   const [highestPackage, setHighestPackage] = useState(null);
  
//   // Eligibility
//   const [isWithdrawalAllowed, setIsWithdrawalAllowed] = useState(true);
//   const [withdrawalMessage, setWithdrawalMessage] = useState('');

//   const cryptoNetworks = {
//     'USDT-TRC20': 'TRON Network (TRC-20)',
//     'USDT-BEP20': 'Binance Smart Chain (BEP-20)'
//   };

//   // Wallet display names mapping (UI only, database remains 'working')
//   const walletDisplayNames = {
//     working: 'AV Power Wallet',
//     roi: 'AV ROI Wallet',
//     energy: 'AV Energy Wallet'
//   };

//   // Wallet icons mapping
//   const walletIcons = {
//     working: <Zap className="text-blue-400" size={20} />,
//     roi: <TrendingUp className="text-green-400" size={20} />,
//     energy: <Battery className="text-purple-400" size={20} />
//   };

//   // Show dialog
//   const showDialog = (type, title, message) => {
//     setDialog({
//       isOpen: true,
//       title,
//       message,
//       type
//     });
//   };

//   // Close dialog
//   const closeDialog = () => {
//     setDialog({
//       isOpen: false,
//       title: '',
//       message: '',
//       type: 'success'
//     });
//   };

//   // Get today's date in user location timezone
//   const getTodayDate = () => {
//     const { timeZone: userTimeZone } = getUserTimeZone();
//     const parts = getTimePartsInTimeZone(new Date(), userTimeZone);
//     const mm = String(parts.month).padStart(2, '0');
//     const dd = String(parts.day).padStart(2, '0');
//     return `${parts.year}-${mm}-${dd}`;
//   };

//   // Initialize
//   useEffect(() => {
//     const storedUserId = localStorage.getItem('userId');
//     const storedDbKey = localStorage.getItem('dbKey');
//     const storedRegDate = localStorage.getItem('registrationDate');
    
//     if (storedUserId) {
//       setUserId(storedUserId);
//       setUserDbKey(storedDbKey);
//       setUserRegistrationDate(storedRegDate || getTodayDate());
//       fetchUserData(storedDbKey, storedRegDate);
//       fetchPackagesData();
//       fetchWithdrawalConditions();
//       fetchDailyWithdrawalCount(storedUserId);
//     }
//   }, []);

//   useEffect(() => {
//     if (userPackages.length > 0) {
//       calculateWithdrawalFee(userPackages);
//     }
//   }, [packagesData, userPackages]);

//   // Calculate withdrawal fee based on highest package
//   const calculateWithdrawalFee = (packages) => {
//     if (!packages || packages.length === 0) {
//       setWithdrawalFee(10);
//       setHighestPackage(null);
//       return;
//     }

//     const getPackageFee = (pkg) => {
//       if (pkg?.withdrawalFee !== undefined && pkg?.withdrawalFee !== null) return pkg.withdrawalFee;
//       const keys = [pkg?.packageName, pkg?.packageId, pkg?.name, pkg?.package];
//       for (const key of keys) {
//         if (key && packagesData?.[key]?.withdrawalFee !== undefined && packagesData?.[key]?.withdrawalFee !== null) {
//           return packagesData[key].withdrawalFee;
//         }
//       }
//       return 10;
//     };

//     let highestPkg = packages[0];
//     let highestAmount = parseFloat(highestPkg.totalAmount || highestPkg.amount || highestPkg.packageAmount || 0);

//     packages.forEach(pkg => {
//       const amount = parseFloat(pkg.totalAmount || pkg.amount || pkg.packageAmount || 0);
//       if (amount > highestAmount) {
//         highestAmount = amount;
//         highestPkg = pkg;
//       }
//     });

//     const fee = getPackageFee(highestPkg);
//     setWithdrawalFee(fee);
//     setHighestPackage(highestPkg);
//   };

//   // Fetch user data from date-wise structure
//   const fetchUserData = async (dbKey, regDate) => {
//     try {
//       if (!dbKey || !regDate) return;
      
//       const userRef = ref(database, `users/${regDate}/${dbKey}`);
//       const snapshot = await get(userRef);
      
//       if (snapshot.exists()) {
//         const userData = snapshot.val();
        
//         // Get wallet balances - still using 'working' from database
//         if (userData.wallets) {
//           setWorkingBalance(parseFloat(userData.wallets.working) || 0);
//           setRoiBalance(parseFloat(userData.wallets.roi) || 0);
//           setEnergyBalance(parseFloat(userData.wallets.energy) || 0);
//         }
        
//         // Check withdrawal status
//         setUserWithdrawalStatus(userData.withdrawalStatus || 'active');

//         // Prefer registrationLocation.country (as requested)
//         const regCountry = userData.registrationLocation?.country || '';
//         const regCity = userData.registrationLocation?.city || '';
//         const regTz = userData.registrationLocation?.timezone || '';
//         if (regCountry) {
//           setUserCountry(regCountry);
//         }
//         if (regCity) {
//           setUserCity(regCity);
//         }
//         if (regTz && regTz.includes('/')) {
//           setUserTimeZoneHint(regTz);
//         }
        
//         // Get packages
//         const userPackages = userData.packages || [];
//         setUserPackages(userPackages);
//         calculateWithdrawalFee(userPackages);
        
//         // Get saved withdrawal addresses only (no auto-fill from Add Fund history)
//         const savedWithdrawalAddresses = userData.withdrawalAddress || {};
//         setUsedCurrenciesData(savedWithdrawalAddresses);
//       }
//     } catch (error) {
//       console.error('Error fetching user data:', error);
//       showDialog('error', 'Error', 'Failed to load user data');
//     }
//   };

//   const normalizeSchedule = (schedule, fallback) => ({
//     days: schedule?.days || fallback.days,
//     startTime1: schedule?.startTime1 ?? fallback.startTime1,
//     endTime1: schedule?.endTime1 ?? fallback.endTime1,
//     slot1Enabled: schedule?.slot1Enabled ?? true,
//     startTime2: schedule?.startTime2 ?? fallback.startTime2,
//     endTime2: schedule?.endTime2 ?? fallback.endTime2,
//     slot2Enabled: schedule?.slot2Enabled ?? true
//   });

//   const normalizeConditions = (data) => ({
//     minWithdrawal: data?.minWithdrawal ?? 12,
//     agPower: normalizeSchedule(data?.agPower || data?.energy, withdrawalConditions.agPower),
//     agRoi: normalizeSchedule(data?.agRoi || data?.roi, withdrawalConditions.agRoi),
//     agEnergy: normalizeSchedule(data?.agEnergy || data?.reward, withdrawalConditions.agEnergy)
//   });

//   // Fetch withdrawal conditions
//   const fetchWithdrawalConditions = async () => {
//     try {
//       const conditionsRef = ref(database, 'withdrawalConditions');
//       const snapshot = await get(conditionsRef);
      
//       if (snapshot.exists()) {
//         setWithdrawalConditions(normalizeConditions(snapshot.val()));
//       }
//     } catch (error) {
//       console.error('Error fetching withdrawal conditions:', error);
//     }
//   };

//   // Fetch package fee settings from admin side
//   const fetchPackagesData = async () => {
//     try {
//       const packagesRef = ref(database, 'Packages');
//       const snapshot = await get(packagesRef);
//       if (snapshot.exists()) {
//         setPackagesData(snapshot.val());
//       }
//     } catch (error) {
//       console.error('Error fetching packages data:', error);
//     }
//   };

//   // Fetch daily withdrawal count
//   const fetchDailyWithdrawalCount = async (userId) => {
//     try {
//       const today = getTodayDate();
//       const withdrawalsRef = ref(database, `withdrawals/${today}`);
//       const snapshot = await get(withdrawalsRef);
      
//       let count = 0;

//       if (snapshot.exists()) {
//         const todayWithdrawals = snapshot.val();
//         if (todayWithdrawals[userId]) {
//           count = Object.keys(todayWithdrawals[userId]).length;
//         }
//       }

//       setDailyWithdrawalCount(count);
//     } catch (error) {
//       console.error('Error fetching daily withdrawal count:', error);
//     }
//   };

//   const GST_TIMEZONE = 'Asia/Dubai';
//   const userCountryName = userCountry.trim();
//   const userCityName = userCity.trim().toLowerCase();

//   const multiTimeZoneCountries = new Set([
//     'Australia',
//     'Brazil',
//     'Canada',
//     'China',
//     'Democratic Republic of the Congo',
//     'Congo',
//     'Ecuador',
//     'France',
//     'Indonesia',
//     'Kazakhstan',
//     'Kiribati',
//     'Mexico',
//     'Micronesia',
//     'Mongolia',
//     'Papua New Guinea',
//     'Portugal',
//     'Russia',
//     'Spain',
//     'United Kingdom',
//     'United States',
//     'United States of America'
//   ]);

//   const countryToTimeZone = {
//     'Afghanistan': 'Asia/Kabul',
//     'Albania': 'Europe/Tirane',
//     'Algeria': 'Africa/Algiers',
//     'Andorra': 'Europe/Andorra',
//     'Angola': 'Africa/Luanda',
//     'Antigua and Barbuda': 'America/Antigua',
//     'Argentina': 'America/Argentina/Buenos_Aires',
//     'Armenia': 'Asia/Yerevan',
//     'Austria': 'Europe/Vienna',
//     'Azerbaijan': 'Asia/Baku',
//     'Bahamas': 'America/Nassau',
//     'Bahrain': 'Asia/Bahrain',
//     'Bangladesh': 'Asia/Dhaka',
//     'Barbados': 'America/Barbados',
//     'Belarus': 'Europe/Minsk',
//     'Belgium': 'Europe/Brussels',
//     'Belize': 'America/Belize',
//     'Benin': 'Africa/Porto-Novo',
//     'Bhutan': 'Asia/Thimphu',
//     'Bolivia': 'America/La_Paz',
//     'Bosnia and Herzegovina': 'Europe/Sarajevo',
//     'Botswana': 'Africa/Gaborone',
//     'Brunei': 'Asia/Brunei',
//     'Bulgaria': 'Europe/Sofia',
//     'Burkina Faso': 'Africa/Ouagadougou',
//     'Burundi': 'Africa/Bujumbura',
//     'Cabo Verde': 'Atlantic/Cape_Verde',
//     'Cambodia': 'Asia/Phnom_Penh',
//     'Cameroon': 'Africa/Douala',
//     'Central African Republic': 'Africa/Bangui',
//     'Chad': 'Africa/Ndjamena',
//     'Chile': 'America/Santiago',
//     'Colombia': 'America/Bogota',
//     'Comoros': 'Indian/Comoro',
//     'Costa Rica': 'America/Costa_Rica',
//     "Cote d'Ivoire": 'Africa/Abidjan',
//     'Croatia': 'Europe/Zagreb',
//     'Cuba': 'America/Havana',
//     'Cyprus': 'Asia/Nicosia',
//     'Czech Republic': 'Europe/Prague',
//     'Denmark': 'Europe/Copenhagen',
//     'Djibouti': 'Africa/Djibouti',
//     'Dominica': 'America/Dominica',
//     'Dominican Republic': 'America/Santo_Domingo',
//     'Egypt': 'Africa/Cairo',
//     'El Salvador': 'America/El_Salvador',
//     'Equatorial Guinea': 'Africa/Malabo',
//     'Eritrea': 'Africa/Asmara',
//     'Estonia': 'Europe/Tallinn',
//     'Eswatini': 'Africa/Mbabane',
//     'Ethiopia': 'Africa/Addis_Ababa',
//     'Fiji': 'Pacific/Fiji',
//     'Finland': 'Europe/Helsinki',
//     'Gabon': 'Africa/Libreville',
//     'Gambia': 'Africa/Banjul',
//     'Georgia': 'Asia/Tbilisi',
//     'Germany': 'Europe/Berlin',
//     'Ghana': 'Africa/Accra',
//     'Greece': 'Europe/Athens',
//     'Grenada': 'America/Grenada',
//     'Guatemala': 'America/Guatemala',
//     'Guinea': 'Africa/Conakry',
//     'Guinea-Bissau': 'Africa/Bissau',
//     'Guyana': 'America/Guyana',
//     'Haiti': 'America/Port-au-Prince',
//     'Honduras': 'America/Tegucigalpa',
//     'Hungary': 'Europe/Budapest',
//     'Iceland': 'Atlantic/Reykjavik',
//     'India': 'Asia/Kolkata',
//     'Iran': 'Asia/Tehran',
//     'Iraq': 'Asia/Baghdad',
//     'Ireland': 'Europe/Dublin',
//     'Israel': 'Asia/Jerusalem',
//     'Italy': 'Europe/Rome',
//     'Hong Kong': 'Asia/Hong_Kong',
//     'Jamaica': 'America/Jamaica',
//     'Japan': 'Asia/Tokyo',
//     'Jordan': 'Asia/Amman',
//     'Kenya': 'Africa/Nairobi',
//     'Kuwait': 'Asia/Kuwait',
//     'Kyrgyzstan': 'Asia/Bishkek',
//     'Laos': 'Asia/Vientiane',
//     'Latvia': 'Europe/Riga',
//     'Lebanon': 'Asia/Beirut',
//     'Lesotho': 'Africa/Maseru',
//     'Liberia': 'Africa/Monrovia',
//     'Libya': 'Africa/Tripoli',
//     'Liechtenstein': 'Europe/Vaduz',
//     'Lithuania': 'Europe/Vilnius',
//     'Luxembourg': 'Europe/Luxembourg',
//     'Madagascar': 'Indian/Antananarivo',
//     'Malawi': 'Africa/Blantyre',
//     'Malaysia': 'Asia/Kuala_Lumpur',
//     'Maldives': 'Indian/Maldives',
//     'Mali': 'Africa/Bamako',
//     'Malta': 'Europe/Malta',
//     'Marshall Islands': 'Pacific/Majuro',
//     'Mauritania': 'Africa/Nouakchott',
//     'Mauritius': 'Indian/Mauritius',
//     'Moldova': 'Europe/Chisinau',
//     'Monaco': 'Europe/Monaco',
//     'Morocco': 'Africa/Casablanca',
//     'Mozambique': 'Africa/Maputo',
//     'Myanmar': 'Asia/Yangon',
//     'Namibia': 'Africa/Windhoek',
//     'Nauru': 'Pacific/Nauru',
//     'Nepal': 'Asia/Kathmandu',
//     'Netherlands': 'Europe/Amsterdam',
//     'New Zealand': 'Pacific/Auckland',
//     'Nicaragua': 'America/Managua',
//     'Niger': 'Africa/Niamey',
//     'Nigeria': 'Africa/Lagos',
//     'North Korea': 'Asia/Pyongyang',
//     'North Macedonia': 'Europe/Skopje',
//     'Norway': 'Europe/Oslo',
//     'Oman': 'Asia/Muscat',
//     'Pakistan': 'Asia/Karachi',
//     'Palau': 'Pacific/Palau',
//     'Palestine': 'Asia/Gaza',
//     'Panama': 'America/Panama',
//     'Paraguay': 'America/Asuncion',
//     'Peru': 'America/Lima',
//     'Philippines': 'Asia/Manila',
//     'Poland': 'Europe/Warsaw',
//     'Qatar': 'Asia/Qatar',
//     'Romania': 'Europe/Bucharest',
//     'Rwanda': 'Africa/Kigali',
//     'Saint Kitts and Nevis': 'America/St_Kitts',
//     'Saint Lucia': 'America/St_Lucia',
//     'Saint Vincent and the Grenadines': 'America/St_Vincent',
//     'Samoa': 'Pacific/Apia',
//     'San Marino': 'Europe/San_Marino',
//     'Sao Tome and Principe': 'Africa/Sao_Tome',
//     'Saudi Arabia': 'Asia/Riyadh',
//     'Senegal': 'Africa/Dakar',
//     'Serbia': 'Europe/Belgrade',
//     'Seychelles': 'Indian/Mahe',
//     'Sierra Leone': 'Africa/Freetown',
//     'Singapore': 'Asia/Singapore',
//     'Slovakia': 'Europe/Bratislava',
//     'Slovenia': 'Europe/Ljubljana',
//     'Solomon Islands': 'Pacific/Guadalcanal',
//     'Somalia': 'Africa/Mogadishu',
//     'South Africa': 'Africa/Johannesburg',
//     'South Korea': 'Asia/Seoul',
//     'South Sudan': 'Africa/Juba',
//     'Sri Lanka': 'Asia/Colombo',
//     'Sudan': 'Africa/Khartoum',
//     'Suriname': 'America/Paramaribo',
//     'Sweden': 'Europe/Stockholm',
//     'Switzerland': 'Europe/Zurich',
//     'Syria': 'Asia/Damascus',
//     'Tajikistan': 'Asia/Dushanbe',
//     'Tanzania': 'Africa/Dar_es_Salaam',
//     'Thailand': 'Asia/Bangkok',
//     'Timor-Leste': 'Asia/Dili',
//     'Togo': 'Africa/Lome',
//     'Tonga': 'Pacific/Tongatapu',
//     'Trinidad and Tobago': 'America/Port_of_Spain',
//     'Tunisia': 'Africa/Tunis',
//     'Turkey': 'Europe/Istanbul',
//     'Turkmenistan': 'Asia/Ashgabat',
//     'Tuvalu': 'Pacific/Funafuti',
//     'Uganda': 'Africa/Kampala',
//     'Ukraine': 'Europe/Kyiv',
//     'United Arab Emirates': 'Asia/Dubai',
//     'Uruguay': 'America/Montevideo',
//     'Uzbekistan': 'Asia/Tashkent',
//     'Vanuatu': 'Pacific/Efate',
//     'Vatican City': 'Europe/Vatican',
//     'Venezuela': 'America/Caracas',
//     'Vietnam': 'Asia/Ho_Chi_Minh',
//     'Yemen': 'Asia/Aden',
//     'Zambia': 'Africa/Lusaka',
//     'Zimbabwe': 'Africa/Harare'
//   };

//   const getCityTimeZone = (country, city) => {
//     if (!country || !city) return null;

//     if (country === 'Indonesia') {
//       if (city.includes('jakarta')) return 'Asia/Jakarta';
//       if (city.includes('bandung')) return 'Asia/Jakarta';
//       if (city.includes('surabaya')) return 'Asia/Jakarta';
//       if (city.includes('medan')) return 'Asia/Jakarta';
//       if (city.includes('yogyakarta')) return 'Asia/Jakarta';
//       if (city.includes('bali') || city.includes('denpasar')) return 'Asia/Makassar';
//       if (city.includes('makassar')) return 'Asia/Makassar';
//       if (city.includes('manado')) return 'Asia/Makassar';
//       if (city.includes('jayapura') || city.includes('papua')) return 'Asia/Jayapura';
//     }

//     if (country === 'United States' || country === 'United States of America') {
//       if (city.includes('new york') || city.includes('washington') || city.includes('boston') || city.includes('miami')) return 'America/New_York';
//       if (city.includes('chicago') || city.includes('dallas') || city.includes('houston')) return 'America/Chicago';
//       if (city.includes('denver') || city.includes('salt lake') || city.includes('phoenix')) return 'America/Denver';
//       if (city.includes('los angeles') || city.includes('san francisco') || city.includes('seattle') || city.includes('las vegas')) return 'America/Los_Angeles';
//       return 'America/New_York';
//     }

//     if (country === 'Canada') {
//       if (city.includes('toronto') || city.includes('ottawa') || city.includes('montreal')) return 'America/Toronto';
//       if (city.includes('vancouver') || city.includes('victoria')) return 'America/Vancouver';
//       if (city.includes('calgary') || city.includes('edmonton')) return 'America/Edmonton';
//       if (city.includes('winnipeg')) return 'America/Winnipeg';
//       if (city.includes('halifax')) return 'America/Halifax';
//       if (city.includes('st. john') || city.includes('st john')) return 'America/St_Johns';
//       return 'America/Toronto';
//     }

//     if (country === 'Australia') {
//       if (city.includes('sydney') || city.includes('melbourne') || city.includes('canberra')) return 'Australia/Sydney';
//       if (city.includes('brisbane')) return 'Australia/Brisbane';
//       if (city.includes('adelaide')) return 'Australia/Adelaide';
//       if (city.includes('perth')) return 'Australia/Perth';
//       if (city.includes('hobart')) return 'Australia/Hobart';
//       if (city.includes('darwin')) return 'Australia/Darwin';
//       return 'Australia/Sydney';
//     }

//     if (country === 'Mexico') {
//       if (city.includes('tijuana')) return 'America/Tijuana';
//       if (city.includes('cancun') || city.includes('merida')) return 'America/Cancun';
//       return 'America/Mexico_City';
//     }

//     if (country === 'Brazil') {
//       if (city.includes('manaus')) return 'America/Manaus';
//       return 'America/Sao_Paulo';
//     }

//     if (country === 'Russia') {
//       if (city.includes('moscow')) return 'Europe/Moscow';
//       if (city.includes('yekaterinburg')) return 'Asia/Yekaterinburg';
//       if (city.includes('novosibirsk')) return 'Asia/Novosibirsk';
//       if (city.includes('vladivostok')) return 'Asia/Vladivostok';
//       return 'Europe/Moscow';
//     }

//     return null;
//   };

//   const getUserTimeZone = () => {
//     const country = userCountryName;
//     if (!country) {
//       const tz = userTimeZoneHint || GST_TIMEZONE;
//       return { timeZone: tz, label: userTimeZoneHint ? 'User Timezone' : 'Unknown Timezone' };
//     }

//     if (multiTimeZoneCountries.has(country)) {
//       const cityTz = getCityTimeZone(country, userCityName);
//       if (cityTz) {
//         return { timeZone: cityTz, label: `${country} Time` };
//       }
//       const tz = userTimeZoneHint || GST_TIMEZONE;
//       return { timeZone: tz, label: userTimeZoneHint ? `${country} Time` : 'Unknown Timezone' };
//     }

//     const tz = countryToTimeZone[country];
//     if (tz) {
//       return { timeZone: tz, label: `${country} Time` };
//     }

//     const fallbackTz = userTimeZoneHint || GST_TIMEZONE;
//     return { timeZone: fallbackTz, label: userTimeZoneHint ? 'User Timezone' : 'Unknown Timezone' };
//   };

//   const getTimePartsInTimeZone = (date, timeZone) => {
//     const parts = new Intl.DateTimeFormat('en-US', {
//       timeZone,
//       weekday: 'long',
//       year: 'numeric',
//       month: '2-digit',
//       day: '2-digit',
//       hour: '2-digit',
//       minute: '2-digit',
//       hour12: false
//     }).formatToParts(date);

//     const map = {};
//     parts.forEach((p) => {
//       map[p.type] = p.value;
//     });

//     return {
//       weekday: map.weekday,
//       year: parseInt(map.year, 10),
//       month: parseInt(map.month, 10),
//       day: parseInt(map.day, 10),
//       hour: map.hour,
//       minute: map.minute
//     };
//   };

//   const getOffsetMinutes = (timeZone, date) => {
//     const parts = new Intl.DateTimeFormat('en-US', {
//       timeZone,
//       timeZoneName: 'shortOffset'
//     }).formatToParts(date);
//     const tzPart = parts.find((p) => p.type === 'timeZoneName')?.value || 'GMT';
//     const match = tzPart.match(/GMT([+-]\d{1,2})(?::(\d{2}))?/);
//     if (!match) return 0;
//     const hours = parseInt(match[1], 10);
//     const minutes = match[2] ? parseInt(match[2], 10) : 0;
//     return hours * 60 + Math.sign(hours) * minutes;
//   };

//   const makeUtcFromZonedTime = (year, month, day, timeStr, timeZone) => {
//     const [h, m] = (timeStr || '00:00').split(':').map(Number);
//     const utcGuess = Date.UTC(year, month - 1, day, h, m, 0);
//     const offsetMinutes = getOffsetMinutes(timeZone, new Date(utcGuess));
//     return new Date(utcGuess - offsetMinutes * 60000);
//   };

//   const formatLocalTimeFromAest = (timeStr, userTimeZone) => {
//     if (!timeStr) return '';
//     const aestParts = getTimePartsInTimeZone(new Date(), GST_TIMEZONE);
//     const localDate = makeUtcFromZonedTime(
//       aestParts.year,
//       aestParts.month,
//       aestParts.day,
//       timeStr,
//       GST_TIMEZONE
//     );
//     return new Intl.DateTimeFormat('en-US', {
//       timeZone: userTimeZone,
//       hour: 'numeric',
//       minute: '2-digit',
//       hour12: true
//     }).format(localDate);
//   };

//   const getDayShiftLabel = (timeStr, userTimeZone) => {
//     if (!timeStr) return '';
//     const aestParts = getTimePartsInTimeZone(new Date(), GST_TIMEZONE);
//     const localDate = makeUtcFromZonedTime(
//       aestParts.year,
//       aestParts.month,
//       aestParts.day,
//       timeStr,
//       GST_TIMEZONE
//     );
//     const localParts = getTimePartsInTimeZone(localDate, userTimeZone);

//     const aestKey = `${aestParts.year}-${String(aestParts.month).padStart(2, '0')}-${String(aestParts.day).padStart(2, '0')}`;
//     const localKey = `${localParts.year}-${String(localParts.month).padStart(2, '0')}-${String(localParts.day).padStart(2, '0')}`;

//     if (localKey < aestKey) return ' (prev day)';
//     if (localKey > aestKey) return ' (next day)';
//     return '';
//   };

//   // Get conditions for current wallet type
//   const getCurrentConditions = () => {
//     switch(withdrawalType) {
//       case 'working': return withdrawalConditions.agPower || {};
//       case 'roi': return withdrawalConditions.agRoi || {};
//       case 'energy': return withdrawalConditions.agEnergy || {};
//       default: return {};
//     }
//   };

//   // Check withdrawal eligibility
//   const checkWithdrawalEligibility = () => {
//     // Check user withdrawal status
//     if (userWithdrawalStatus === 'blocked') {
//       setIsWithdrawalAllowed(false);
//       setWithdrawalMessage('Your withdrawal has been blocked by admin. Please contact support.');
//       return;
//     }

//     if (userWithdrawalStatus === 'paused') {
//       setIsWithdrawalAllowed(false);
//       setWithdrawalMessage('Your withdrawal is temporarily paused. Please contact support.');
//       return;
//     }

//     // Check daily limit
//     if (dailyWithdrawalCount >= maxDailyWithdrawals) {
//       setIsWithdrawalAllowed(false);
//       setWithdrawalMessage(`Daily withdrawal limit reached (${maxDailyWithdrawals} per day)`);
//       return;
//     }

//     // Check minimum amount
//     const minAmount = withdrawalConditions.minWithdrawal || 12;
//     if (amount && parseFloat(amount) < minAmount) {
//       setIsWithdrawalAllowed(false);
//       setWithdrawalMessage(`Minimum withdrawal is $${minAmount}`);
//       return;
//     }

//     // Check balance
//     if (amount && parseFloat(amount) > getAvailableBalance()) {
//       setIsWithdrawalAllowed(false);
//       setWithdrawalMessage('Insufficient balance');
//       return;
//     }

//     const conditions = getCurrentConditions();
//     const slot1Enabled = conditions?.slot1Enabled ?? true;
//     const slot2Enabled = conditions?.slot2Enabled ?? true;
//     const hasAnySlotEnabled = slot1Enabled || slot2Enabled;
//     const days = conditions?.days || [];

//     if (!hasAnySlotEnabled) {
//       setIsWithdrawalAllowed(false);
//       setWithdrawalMessage('Withdrawal time slots are disabled by admin.');
//       return;
//     }

//     // Check day restrictions only (ignore time restrictions)
//     if (days.length > 0 && !days.includes('Everyday')) {
//       const now = new Date();
//       const { timeZone: userTimeZone } = getUserTimeZone();
//       const userNow = getTimePartsInTimeZone(now, userTimeZone);
//       const currentDay = userNow.weekday;
//       if (!days.includes(currentDay)) {
//         setIsWithdrawalAllowed(false);
//         setWithdrawalMessage(`Only allowed on: ${days.join(', ')}`);
//         return;
//       }
//     }

//     setIsWithdrawalAllowed(true);
//     setWithdrawalMessage('');
//   };

//   // Check time slot
//   const checkTimeSlot = (conditions, currentTime) => {
//     const slot1Enabled = conditions.slot1Enabled ?? true;
//     const slot2Enabled = conditions.slot2Enabled ?? true;

//     if (!slot1Enabled && !slot2Enabled) return true;

//     const current = convertToMinutes(currentTime);
//     if (slot1Enabled && conditions.startTime1 && conditions.endTime1) {
//       const start1 = convertToMinutes(conditions.startTime1);
//       const end1 = convertToMinutes(conditions.endTime1);
//       if (current >= start1 && current <= end1) return true;
//     }

//     if (slot2Enabled && conditions.startTime2 && conditions.endTime2) {
//       const start2 = convertToMinutes(conditions.startTime2);
//       const end2 = convertToMinutes(conditions.endTime2);
//       if (current >= start2 && current <= end2) return true;
//     }

//     return false;
//   };

//   // Convert time to minutes
//   const convertToMinutes = (time) => {
//     if (!time) return 0;
//     const [hours, minutes] = time.split(':').map(Number);
//     return hours * 60 + minutes;
//   };

//   // Format time display
//   const formatTimeDisplay = (conditions) => {
//     const { timeZone } = getUserTimeZone();
//     const ranges = [];

//     if (conditions.startTime1 && conditions.endTime1) {
//       ranges.push(
//         `${formatLocalTimeFromAest(conditions.startTime1, timeZone)} - ${formatLocalTimeFromAest(conditions.endTime1, timeZone)}${getDayShiftLabel(conditions.startTime1, timeZone)}`
//       );
//     }

//     if (conditions.startTime2 && conditions.endTime2) {
//       ranges.push(
//         `${formatLocalTimeFromAest(conditions.startTime2, timeZone)} - ${formatLocalTimeFromAest(conditions.endTime2, timeZone)}${getDayShiftLabel(conditions.startTime2, timeZone)}`
//       );
//     }

//     if (ranges.length === 0) return 'All day';
//     return ranges.join(', ');
//   };

//   // Re-check eligibility
//   useEffect(() => {
//     checkWithdrawalEligibility();
//   }, [userWithdrawalStatus, dailyWithdrawalCount, amount, withdrawalType, withdrawalConditions]);

//   // Handle cryptocurrency selection
//   const handleCryptoSelect = (crypto) => {
//     setSelectedCrypto(crypto);
//     setCryptoAddress(usedCurrenciesData[crypto]?.address || '');
//   };

//   // Handle withdrawal
//   const handleWithdrawal = async (e) => {
//     e.preventDefault();

//     // Check eligibility
//     if (!isWithdrawalAllowed) {
//       showDialog('error', 'Not Allowed', withdrawalMessage);
//       return;
//     }

//     const minAmount = withdrawalConditions.minWithdrawal || 12;
//     if (!amount || parseFloat(amount) < minAmount) {
//       showDialog('error', 'Invalid Amount', `Minimum: $${minAmount}`);
//       return;
//     }

//     if (parseFloat(amount) > getAvailableBalance()) {
//       showDialog('error', 'Insufficient Balance', 'Not enough balance');
//       return;
//     }

//     if (!selectedCrypto || !cryptoAddress.trim()) {
//       showDialog('error', 'Missing Info', 'Select crypto and enter address');
//       return;
//     }

//     setLoading(true);
    
//     try {
//       const withdrawalId = `WDR${Date.now()}`;
//       const today = getTodayDate();
      
//       const feeAmount = (parseFloat(amount) * withdrawalFee) / 100;
//       const netAmount = parseFloat(amount) - feeAmount;

//       const withdrawalData = {
//         id: withdrawalId,
//         userId,
//         userDbKey,
//         userName: localStorage.getItem('userName') || 'User',
//         amount: parseFloat(amount),
//         netAmount,
//         feeAmount,
//         withdrawalFee,
//        walletType: withdrawalType === 'working' ? 'AV Power Wallet' : withdrawalType === 'roi' ? 'AV ROI Wallet' : 'AV Energy Wallet',
//         requestDate: new Date().toISOString(),
//         crypto: {
//           currency: selectedCrypto,
//           network: cryptoNetworks[selectedCrypto],
//           address: cryptoAddress.trim()
//         },
//         date: today
//       };

//       // Save withdrawal in date-wise structure
//       const withdrawalRef = ref(database, `withdrawals/${today}/${userId}/${withdrawalId}`);
//       await set(withdrawalRef, withdrawalData);

//       // Update wallet balance
//       await updateWalletBalance(parseFloat(amount));

//       // Save (or update) selected crypto address for future reuse
//       await saveWithdrawalAddress(cryptoAddress.trim());

//       // Update daily count
//       setDailyWithdrawalCount(prev => prev + 1);

//       // Show success
//       showDialog('success', 'Success', 
//         `Withdrawal Request Submitted!\n\n` +
//         `Amount: $${amount}\n` +
//         `Fee: ${withdrawalFee}% ($${feeAmount.toFixed(2)})\n` +
//         `Net: $${netAmount.toFixed(2)}\n` +
//         `Status: Pending\n\n` +
//         `Please wait for admin approval.`
//       );

//       // Reset form
//       setAmount('');
      
//       // Refresh data
//       fetchUserData(userDbKey, userRegistrationDate);

//     } catch (error) {
//       console.error('Withdrawal error:', error);
//       showDialog('error', 'Error', 'Failed to process withdrawal');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Update wallet balance
//   const updateWalletBalance = async (amount) => {
//     try {
//       const userRef = ref(database, `users/${userRegistrationDate}/${userDbKey}`);
//       const snapshot = await get(userRef);
      
//       if (snapshot.exists()) {
//         const userData = snapshot.val();
//         const updates = {};
        
//         let balanceField = '';
//         switch(withdrawalType) {
//           case 'working': balanceField = 'wallets/working'; break;
//           case 'roi': balanceField = 'wallets/roi'; break;
//           case 'energy': balanceField = 'wallets/energy'; break;
//         }
        
//         const currentBalance = parseFloat(userData.wallets?.[withdrawalType]) || 0;
//         const newBalance = Math.max(0, currentBalance - amount);
//         updates[balanceField] = newBalance;
        
//         await update(userRef, updates);
        
//         // Update local state
//         switch(withdrawalType) {
//           case 'working': setWorkingBalance(newBalance); break;
//           case 'roi': setRoiBalance(newBalance); break;
//           case 'energy': setEnergyBalance(newBalance); break;
//         }
//       }
//     } catch (error) {
//       console.error('Error updating wallet:', error);
//       throw error;
//     }
//   };

//   // Save withdrawal address
//   const saveWithdrawalAddress = async (address) => {
//     try {
//       const userRef = ref(database, `users/${userRegistrationDate}/${userDbKey}`);
//       const snapshot = await get(userRef);
      
//       if (snapshot.exists()) {
//         const userData = snapshot.val();
//         const updates = {};
        
//         const withdrawalAddress = userData.withdrawalAddress || {};
//         withdrawalAddress[selectedCrypto] = {
//           address: address,
//           saved: true,
//           savedAt: new Date().toISOString()
//         };
        
//         updates['withdrawalAddress'] = withdrawalAddress;
//         await update(userRef, updates);
        
//         setUsedCurrenciesData(prev => ({
//           ...prev,
//           [selectedCrypto]: withdrawalAddress[selectedCrypto]
//         }));
//       }
//     } catch (error) {
//       console.error('Error saving address:', error);
//     }
//   };

//   // Copy to clipboard
//   const copyToClipboard = (text) => {
//     navigator.clipboard.writeText(text).then(() => {
//       showDialog('success', 'Copied', 'Address copied!');
//     });
//   };

//   // Helper functions
//   const getAvailableBalance = () => {
//     switch(withdrawalType) {
//       case 'working': return workingBalance;
//       case 'roi': return roiBalance;
//       case 'energy': return energyBalance;
//       default: return 0;
//     }
//   };

//   const formatBalance = (value) => `$${parseFloat(value || 0).toFixed(2)}`;

//   const usedCurrencies = Object.keys(usedCurrenciesData);
//   const isSavedAddressSelected = Boolean(
//     selectedCrypto &&
//     usedCurrenciesData[selectedCrypto]?.address &&
//     cryptoAddress === usedCurrenciesData[selectedCrypto]?.address
//   );
//   const hasWithdrawnToday = dailyWithdrawalCount >= maxDailyWithdrawals;
//   const today = getTodayDate();
//   const minWithdrawal = withdrawalConditions.minWithdrawal || 12;
//   const disableReasons = [];
//   if (loading) disableReasons.push('Processing');
//   if (!amount) disableReasons.push('Enter amount');
//   if (!selectedCrypto) disableReasons.push('Select crypto');
//   if (!cryptoAddress) disableReasons.push('Enter address');
//   if (!isWithdrawalAllowed) disableReasons.push('Not allowed by rules');
//   const isSubmitDisabled = loading || !amount || !selectedCrypto || !cryptoAddress || !isWithdrawalAllowed;
//   const { label: userTimeZoneLabel } = getUserTimeZone();
  
//   // Get current conditions for display
//   const currentConditions = getCurrentConditions();

//   return (
//     <div className="max-w-4xl mx-auto pt-20 px-4 pb-8">
//       {/* Dialog */}
//       <Dialog
//         isOpen={dialog.isOpen}
//         onClose={closeDialog}
//         title={dialog.title}
//         message={dialog.message}
//         type={dialog.type}
//       />

//       {/* Header */}
//       <div className="mb-6">
//         <h1 className="text-2xl font-bold text-white mb-2">Crypto Withdrawal</h1>
//         <p className="text-gray-400">Withdraw funds from your wallets</p>
//       </div>

//       {/* User Status Banner */}
//       {userWithdrawalStatus !== 'active' && (
//         <div className={`mb-6 p-4 rounded-xl border ${
//           userWithdrawalStatus === 'blocked' 
//             ? 'bg-red-900/20 border-red-500/30' 
//             : 'bg-yellow-900/20 border-yellow-500/30'
//         }`}>
//           <div className="flex items-center gap-3">
//             <Shield className={
//               userWithdrawalStatus === 'blocked' ? 'text-red-400' : 'text-yellow-400'
//             } size={20} />
//             <div>
//               <p className="font-medium text-white">
//                 Withdrawal {userWithdrawalStatus.charAt(0).toUpperCase() + userWithdrawalStatus.slice(1)}
//               </p>
//               <p className="text-gray-300 text-sm mt-1">
//                 {userWithdrawalStatus === 'blocked'
//                   ? 'Your withdrawal has been blocked by admin. Please contact support.'
//                   : 'Your withdrawal is temporarily paused. Please contact support.'}
//               </p>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Daily Limit Card */}
//       <div className="bg-gray-800 border border-gray-700 rounded-xl p-4 mb-6">
//         <div className="flex items-center justify-between">
//           <div>
//             <p className="text-gray-400 text-sm">Daily Withdrawals</p>
//             <p className={`text-xl font-bold ${hasWithdrawnToday ? 'text-red-400' : 'text-white'}`}>
//               {dailyWithdrawalCount} / {maxDailyWithdrawals}
//             </p>
//           </div>
//           <div className="text-right">
//             <p className="text-gray-400 text-sm">Today</p>
//             <p className="text-white">{today}</p>
//           </div>
//         </div>
//         {hasWithdrawnToday && (
//           <p className="text-red-400 text-sm mt-2">
//             Daily limit reached. Try again tomorrow.
//           </p>
//         )}
//       </div>

//       {/* Package Fee Card */}
//       {highestPackage && (
//         <div className="bg-purple-900/20 border border-purple-500/30 rounded-xl p-4 mb-6">
//           <div className="flex items-center justify-between">
//             <div className="flex items-center gap-3">
//               <Package className="text-purple-400" size={20} />
//               <div>
//                 <p className="text-purple-200 text-sm">Based on Highest Package</p>
//                 <p className="text-white font-bold">
//                   {highestPackage.packageName || 'Package'} - {withdrawalFee}% Fee
//                 </p>
//               </div>
//             </div>
//             <div className="text-purple-300 font-bold">
//               ${parseFloat(highestPackage.totalAmount || highestPackage.amount || 0).toFixed(2)}
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Wallet Selection - UI shows AV Power Wallet but database remains 'working' */}
//       <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-6">
//         {[
//           { type: 'working', name: 'AV Power Wallet', balance: workingBalance, icon: walletIcons.working },
//           { type: 'roi', name: 'AV ROI Wallet', balance: roiBalance, icon: walletIcons.roi },
//           { type: 'energy', name: 'AV Energy Wallet', balance: energyBalance, icon: walletIcons.energy }
//         ].map((wallet) => (
//           <button
//             key={wallet.type}
//             onClick={() => setWithdrawalType(wallet.type)}
//             disabled={hasWithdrawnToday || userWithdrawalStatus !== 'active'}
//             className={`p-3 border rounded-xl text-left transition-all ${
//               hasWithdrawnToday || userWithdrawalStatus !== 'active'
//                 ? 'opacity-50 cursor-not-allowed'
//                 : withdrawalType === wallet.type
//                 ? 'border-blue-500 bg-blue-900/20'
//                 : 'border-gray-700 hover:border-gray-600'
//             }`}
//           >
//             <div className="flex justify-between items-center">
//               <div className="flex items-center gap-2">
//                 {wallet.icon}
//                 <div>
//                   <p className="text-gray-400 text-sm">{wallet.name}</p>
//                   <p className="text-white font-bold text-lg">
//                     {formatBalance(wallet.balance)}
//                   </p>
//                 </div>
//               </div>
//               {withdrawalType === wallet.type && (
//                 <Check className="text-blue-400" size={16} />
//               )}
//             </div>
//           </button>
//         ))}
//       </div>

//       {/* Withdrawal Conditions - UI shows correct wallet names */}
//       <div className="bg-gray-800 border border-gray-700 rounded-xl p-4 mb-6">
//         <h3 className="text-white font-medium mb-3">Conditions for {withdrawalType === 'working' ? 'AV Power' : withdrawalType === 'roi' ? 'AV ROI' : 'AV Energy'} Wallet</h3>
//         <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
//           <div className="flex items-center gap-2 text-gray-400">
//             <CreditCard size={14} />
//             <span>Min: ${minWithdrawal}</span>
//           </div>
//           <div className="flex items-center gap-2 text-gray-400">
//             <Calendar size={14} />
//             <span>Days: {currentConditions.days?.join(', ') || 'Everyday'}</span>
//           </div>
//           <div className="flex items-center gap-2 text-gray-400">
//             <Clock size={14} />
//             <span>Time ({userTimeZoneLabel}): {formatTimeDisplay(currentConditions)}</span>
//           </div>
//           <div className="flex items-center gap-2 text-gray-400">
//             <Wallet size={14} />
//             <span>Fee: {withdrawalFee}%</span>
//           </div>
//         </div>
//         {/* <div className="mt-3 text-xs text-gray-500">
//           User Location : {userCountry || 'Unknown'}{userCity ? `, ${userCity}` : ''}{userTimeZoneHint ? ` (${userTimeZoneHint})` : ' (timezone unknown)'}
//         </div> */}
//       </div>

//       {/* Withdrawal Form */}
//       {userWithdrawalStatus === 'active' && !hasWithdrawnToday && (
//         <div className="bg-gray-800 border border-gray-700 rounded-xl p-4 md:p-6">
//           <form onSubmit={handleWithdrawal} className="space-y-4">
//             {/* Amount */}
//             <div>
//               <label className="block text-white mb-2">Amount (USD)</label>
//               <div className="relative">
//                 <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">$</span>
//                 <input
//                   type="number"
//                   value={amount}
//                   onChange={(e) => setAmount(e.target.value)}
//                   placeholder={`Min: $${minWithdrawal}`}
//                   min={minWithdrawal}
//                   step="0.01"
//                   className="w-full pl-8 pr-3 py-2.5 bg-gray-900 border border-gray-700 rounded-lg text-white"
//                   required
//                 />
//               </div>
//               <p className="text-gray-400 text-sm mt-1">
//                 Available: {formatBalance(getAvailableBalance())}
//               </p>
//             </div>

//             {/* Cryptocurrency Selection */}
//             <div>
//               <label className="block text-white mb-2">Select Cryptocurrency</label>
//               <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
//                 {availableCurrencies.map((crypto) => (
//                   <button
//                     key={crypto}
//                     type="button"
//                     onClick={() => handleCryptoSelect(crypto)}
//                     className={`p-3 border rounded-lg text-left ${
//                       selectedCrypto === crypto
//                         ? 'border-blue-500 bg-blue-900/20'
//                         : 'border-gray-700 hover:border-gray-600'
//                     }`}
//                   >
//                     <div className="flex justify-between items-center">
//                       <div>
//                         <p className="text-white text-sm font-medium">{crypto}</p>
//                         <p className="text-gray-400 text-xs">{cryptoNetworks[crypto]}</p>
//                       </div>
//                       {usedCurrencies.includes(crypto) && (
//                         <Lock size={14} className="text-yellow-400" />
//                       )}
//                     </div>
//                   </button>
//                 ))}
//               </div>
//             </div>

//             {/* Address Input */}
//             {selectedCrypto && (
//               <div>
//                 <label className="block text-white mb-2">{selectedCrypto} Address</label>
//                 <div className="relative">
//                   <input
//                     type="text"
//                     value={cryptoAddress}
//                     onChange={(e) => {
//                       if (!isSavedAddressSelected) {
//                         setCryptoAddress(e.target.value);
//                       }
//                     }}
//                     readOnly={isSavedAddressSelected}
//                     placeholder={`Enter ${selectedCrypto} address`}
//                     className={`w-full pl-3 pr-10 py-2.5 bg-gray-900 border border-gray-700 rounded-lg text-white ${
//                       isSavedAddressSelected ? 'opacity-70 cursor-not-allowed' : ''
//                     }`}
//                     required
//                   />
//                   {cryptoAddress && (
//                     <button
//                       type="button"
//                       onClick={() => copyToClipboard(cryptoAddress)}
//                       className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-white"
//                     >
//                       <Copy size={16} />
//                     </button>
//                   )}
//                 </div>
//               </div>
//             )}

//             {/* Fee Calculation */}
//             {amount && parseFloat(amount) >= minWithdrawal && (
//               <div className="bg-gray-900 border border-gray-700 rounded-lg p-3">
//                 <div className="grid grid-cols-3 gap-2 text-center">
//                   <div>
//                     <p className="text-gray-400 text-xs">Amount</p>
//                     <p className="text-white font-bold text-sm">${parseFloat(amount).toFixed(2)}</p>
//                   </div>
//                   <div>
//                     <p className="text-gray-400 text-xs">Fee ({withdrawalFee}%)</p>
//                     <p className="text-red-400 font-bold text-sm">
//                       ${((parseFloat(amount) * withdrawalFee) / 100).toFixed(2)}
//                     </p>
//                   </div>
//                   <div>
//                     <p className="text-gray-400 text-xs">You Receive</p>
//                     <p className="text-green-400 font-bold text-sm">
//                       ${(parseFloat(amount) - (parseFloat(amount) * withdrawalFee) / 100).toFixed(2)}
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             )}

//             {/* Submit Button */}
//             <button
//               type="submit"
//               disabled={isSubmitDisabled}
//               className={`w-full py-3 font-bold rounded-lg transition-all ${
//                 isSubmitDisabled
//                   ? 'bg-gray-700 cursor-not-allowed text-gray-400'
//                   : 'bg-blue-600 hover:bg-blue-700 text-white'
//               }`}
//             >
//               {loading ? (
//                 <div className="flex items-center justify-center gap-2">
//                   <Loader2 className="animate-spin" size={18} />
//                   Processing...
//                 </div>
//               ) : (
//                 <div className="flex items-center justify-center gap-2">
//                   <Send size={18} />
//                   Submit Withdrawal
//                 </div>
//               )}
//             </button>

//             {/* Error Message */}
//             {!isWithdrawalAllowed && (
//               <div className="p-3 bg-red-900/20 border border-red-500/30 rounded-lg">
//                 <p className="text-red-400 text-sm">{withdrawalMessage}</p>
//               </div>
//             )}

//             {isSubmitDisabled && disableReasons.length > 0 && (
//               <div className="p-3 bg-gray-900 border border-gray-700 rounded-lg">
//                 <p className="text-gray-300 text-xs">
//                   Disabled because: {disableReasons.join(', ')}
//                 </p>
//               </div>
//             )}
//           </form>
//         </div>
//       )}

//       {/* Footer Info */}
//       <div className="mt-6 text-center text-gray-400 text-sm">
//         <p>Daily limit: {maxDailyWithdrawals} withdrawal per day</p>
//         <p className="mt-1">Withdrawal requests require admin approval</p>
//       </div>
//     </div>
//   );
// };

// export default RequestWithdrawal;




import React, { useState, useEffect } from 'react';
import { database, ref, get, set, update } from '../../firebase';
import { Wallet, Send, Loader2, Check, Copy, Calendar, Clock, CreditCard, Lock, Package, AlertCircle, Shield, XCircle, Zap, TrendingUp, Battery } from 'lucide-react';

// Dialog Component (keep as is)
const Dialog = ({ isOpen, onClose, title, message, type = 'success' }) => {
  if (!isOpen) return null;

  const getIcon = () => {
    switch(type) {
      case 'error': return <XCircle className="text-red-400" size={40} />;
      case 'warning': return <AlertCircle className="text-yellow-400" size={40} />;
      default: return <Check className="text-green-400" size={40} />;
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div 
        className="absolute inset-0 bg-black/70 backdrop-blur-sm"
        onClick={onClose}
      />
      
      <div className="relative z-10 w-full max-w-sm bg-gray-900 border border-gray-700 rounded-xl p-6 shadow-2xl">
        <button
          onClick={onClose}
          className="absolute right-3 top-3 text-gray-400 hover:text-white"
        >
          ✕
        </button>

        <div className="text-center">
          <div className="flex justify-center mb-4">
            {getIcon()}
          </div>
          
          <h3 className="text-xl font-bold text-white mb-3">
            {title}
          </h3>
          
          <div className="text-gray-200 text-sm mb-6 whitespace-pre-line">
            {message}
          </div>
          
          <button
            onClick={onClose}
            className={`px-6 py-2 rounded-lg font-medium text-sm ${
              type === 'success' 
                ? 'bg-blue-600 hover:bg-blue-700 text-white' 
                : type === 'error'
                ? 'bg-red-600 hover:bg-red-700 text-white'
                : 'bg-yellow-600 hover:bg-yellow-700 text-white'
            }`}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

const RequestWithdrawal = () => {
  // User states
  const [workingBalance, setWorkingBalance] = useState(0);
  const [roiBalance, setRoiBalance] = useState(0);
  const [energyBalance, setEnergyBalance] = useState(0);
  const [userId, setUserId] = useState('');
  const [userDbKey, setUserDbKey] = useState('');
  const [userRegistrationDate, setUserRegistrationDate] = useState('');
  const [userWithdrawalStatus, setUserWithdrawalStatus] = useState('active');
  const [loading, setLoading] = useState(false);
  const [withdrawalType, setWithdrawalType] = useState('working');
  const [userCountry, setUserCountry] = useState('');
  const [userCity, setUserCity] = useState('');
  const [userTimeZoneHint, setUserTimeZoneHint] = useState('');
  
  // Dialog states
  const [dialog, setDialog] = useState({
    isOpen: false,
    title: '',
    message: '',
    type: 'success'
  });
  
  // Withdrawal conditions (stored in GST)
  const [withdrawalConditions, setWithdrawalConditions] = useState({
    minWithdrawal: 12,
    agPower: { days: ['Everyday'], startTime1: '00:00', endTime1: '03:00', slot1Enabled: true, startTime2: '12:00', endTime2: '15:00', slot2Enabled: true },
    agRoi: { days: ['Wednesday'], startTime1: '00:00', endTime1: '03:00', slot1Enabled: true, startTime2: '12:00', endTime2: '15:00', slot2Enabled: true },
    agEnergy: { days: ['Saturday'], startTime1: '00:00', endTime1: '03:00', slot1Enabled: true, startTime2: '12:00', endTime2: '15:00', slot2Enabled: true }
  });
  
  // Daily withdrawal limit
  const [dailyWithdrawalCount, setDailyWithdrawalCount] = useState(0);
  const [maxDailyWithdrawals] = useState(1);
  
  // Cryptocurrency
  const [availableCurrencies] = useState(['USDT-TRC20', 'USDT-BEP20']);
  const [usedCurrenciesData, setUsedCurrenciesData] = useState({});
  const [selectedCrypto, setSelectedCrypto] = useState('');
  const [amount, setAmount] = useState('');
  const [cryptoAddress, setCryptoAddress] = useState('');
  
  // Packages and fee
  const [userPackages, setUserPackages] = useState([]);
  const [packagesData, setPackagesData] = useState({});
  const [withdrawalFee, setWithdrawalFee] = useState(10);
  const [highestPackage, setHighestPackage] = useState(null);
  
  // Eligibility
  const [isWithdrawalAllowed, setIsWithdrawalAllowed] = useState(true);
  const [withdrawalMessage, setWithdrawalMessage] = useState('');

  const cryptoNetworks = {
    'USDT-TRC20': 'TRON Network (TRC-20)',
    'USDT-BEP20': 'Binance Smart Chain (BEP-20)'
  };

  // Wallet display names mapping (UI only, database remains 'working')
  const walletDisplayNames = {
    working: 'AV Power Wallet',
    roi: 'AV ROI Wallet',
    energy: 'AV Energy Wallet'
  };

  // Wallet icons mapping
  const walletIcons = {
    working: <Zap className="text-blue-400" size={18} />,
    roi: <TrendingUp className="text-green-400" size={18} />,
    energy: <Battery className="text-purple-400" size={18} />
  };

  // Show dialog
  const showDialog = (type, title, message) => {
    setDialog({
      isOpen: true,
      title,
      message,
      type
    });
  };

  // Close dialog
  const closeDialog = () => {
    setDialog({
      isOpen: false,
      title: '',
      message: '',
      type: 'success'
    });
  };

  // Get today's date in user location timezone
  const getTodayDate = () => {
    const { timeZone: userTimeZone } = getUserTimeZone();
    const parts = getTimePartsInTimeZone(new Date(), userTimeZone);
    const mm = String(parts.month).padStart(2, '0');
    const dd = String(parts.day).padStart(2, '0');
    return `${parts.year}-${mm}-${dd}`;
  };

  // Initialize
  useEffect(() => {
    const storedUserId = localStorage.getItem('userId');
    const storedDbKey = localStorage.getItem('dbKey');
    const storedRegDate = localStorage.getItem('registrationDate');
    
    if (storedUserId) {
      setUserId(storedUserId);
      setUserDbKey(storedDbKey);
      setUserRegistrationDate(storedRegDate || getTodayDate());
      fetchUserData(storedDbKey, storedRegDate);
      fetchPackagesData();
      fetchWithdrawalConditions();
      fetchDailyWithdrawalCount(storedUserId);
    }
  }, []);

  useEffect(() => {
    if (userPackages.length > 0) {
      calculateWithdrawalFee(userPackages);
    }
  }, [packagesData, userPackages]);

  // Calculate withdrawal fee based on highest package
  const calculateWithdrawalFee = (packages) => {
    if (!packages || packages.length === 0) {
      setWithdrawalFee(10);
      setHighestPackage(null);
      return;
    }

    const getPackageFee = (pkg) => {
      if (pkg?.withdrawalFee !== undefined && pkg?.withdrawalFee !== null) return pkg.withdrawalFee;
      const keys = [pkg?.packageName, pkg?.packageId, pkg?.name, pkg?.package];
      for (const key of keys) {
        if (key && packagesData?.[key]?.withdrawalFee !== undefined && packagesData?.[key]?.withdrawalFee !== null) {
          return packagesData[key].withdrawalFee;
        }
      }
      return 10;
    };

    let highestPkg = packages[0];
    let highestAmount = parseFloat(highestPkg.totalAmount || highestPkg.amount || highestPkg.packageAmount || 0);

    packages.forEach(pkg => {
      const amount = parseFloat(pkg.totalAmount || pkg.amount || pkg.packageAmount || 0);
      if (amount > highestAmount) {
        highestAmount = amount;
        highestPkg = pkg;
      }
    });

    const fee = getPackageFee(highestPkg);
    setWithdrawalFee(fee);
    setHighestPackage(highestPkg);
  };

  // Fetch user data from date-wise structure
  const fetchUserData = async (dbKey, regDate) => {
    try {
      if (!dbKey || !regDate) return;
      
      const userRef = ref(database, `users/${regDate}/${dbKey}`);
      const snapshot = await get(userRef);
      
      if (snapshot.exists()) {
        const userData = snapshot.val();
        
        // Get wallet balances - still using 'working' from database
        if (userData.wallets) {
          setWorkingBalance(parseFloat(userData.wallets.working) || 0);
          setRoiBalance(parseFloat(userData.wallets.roi) || 0);
          setEnergyBalance(parseFloat(userData.wallets.energy) || 0);
        }
        
        // Check withdrawal status
        setUserWithdrawalStatus(userData.withdrawalStatus || 'active');

        // Prefer registrationLocation.country (as requested)
        const regCountry = userData.registrationLocation?.country || '';
        const regCity = userData.registrationLocation?.city || '';
        const regTz = userData.registrationLocation?.timezone || '';
        if (regCountry) {
          setUserCountry(regCountry);
        }
        if (regCity) {
          setUserCity(regCity);
        }
        if (regTz && regTz.includes('/')) {
          setUserTimeZoneHint(regTz);
        }
        
        // Get packages
        const userPackages = userData.packages || [];
        setUserPackages(userPackages);
        calculateWithdrawalFee(userPackages);
        
        // Get saved withdrawal addresses only (no auto-fill from Add Fund history)
        const savedWithdrawalAddresses = userData.withdrawalAddress || {};
        setUsedCurrenciesData(savedWithdrawalAddresses);
      }
    } catch (error) {
      console.error('Error fetching user data:', error);
      showDialog('error', 'Error', 'Failed to load user data');
    }
  };

  const normalizeSchedule = (schedule, fallback) => ({
    days: schedule?.days || fallback.days,
    startTime1: schedule?.startTime1 ?? fallback.startTime1,
    endTime1: schedule?.endTime1 ?? fallback.endTime1,
    slot1Enabled: schedule?.slot1Enabled ?? true,
    startTime2: schedule?.startTime2 ?? fallback.startTime2,
    endTime2: schedule?.endTime2 ?? fallback.endTime2,
    slot2Enabled: schedule?.slot2Enabled ?? true
  });

  const normalizeConditions = (data) => ({
    minWithdrawal: data?.minWithdrawal ?? 12,
    agPower: normalizeSchedule(data?.agPower || data?.energy, withdrawalConditions.agPower),
    agRoi: normalizeSchedule(data?.agRoi || data?.roi, withdrawalConditions.agRoi),
    agEnergy: normalizeSchedule(data?.agEnergy || data?.reward, withdrawalConditions.agEnergy)
  });

  // Fetch withdrawal conditions
  const fetchWithdrawalConditions = async () => {
    try {
      const conditionsRef = ref(database, 'withdrawalConditions');
      const snapshot = await get(conditionsRef);
      
      if (snapshot.exists()) {
        setWithdrawalConditions(normalizeConditions(snapshot.val()));
      }
    } catch (error) {
      console.error('Error fetching withdrawal conditions:', error);
    }
  };

  // Fetch package fee settings from admin side
  const fetchPackagesData = async () => {
    try {
      const packagesRef = ref(database, 'Packages');
      const snapshot = await get(packagesRef);
      if (snapshot.exists()) {
        setPackagesData(snapshot.val());
      }
    } catch (error) {
      console.error('Error fetching packages data:', error);
    }
  };

  // Fetch daily withdrawal count
  const fetchDailyWithdrawalCount = async (userId) => {
    try {
      const today = getTodayDate();
      const withdrawalsRef = ref(database, `withdrawals/${today}`);
      const snapshot = await get(withdrawalsRef);
      
      let count = 0;

      if (snapshot.exists()) {
        const todayWithdrawals = snapshot.val();
        if (todayWithdrawals[userId]) {
          count = Object.keys(todayWithdrawals[userId]).length;
        }
      }

      setDailyWithdrawalCount(count);
    } catch (error) {
      console.error('Error fetching daily withdrawal count:', error);
    }
  };

  const GST_TIMEZONE = 'Asia/Dubai';
  const userCountryName = userCountry.trim();
  const userCityName = userCity.trim().toLowerCase();

  const multiTimeZoneCountries = new Set([
    'Australia',
    'Brazil',
    'Canada',
    'China',
    'Democratic Republic of the Congo',
    'Congo',
    'Ecuador',
    'France',
    'Indonesia',
    'Kazakhstan',
    'Kiribati',
    'Mexico',
    'Micronesia',
    'Mongolia',
    'Papua New Guinea',
    'Portugal',
    'Russia',
    'Spain',
    'United Kingdom',
    'United States',
    'United States of America'
  ]);

  const countryToTimeZone = {
    'Afghanistan': 'Asia/Kabul',
    'Albania': 'Europe/Tirane',
    'Algeria': 'Africa/Algiers',
    'Andorra': 'Europe/Andorra',
    'Angola': 'Africa/Luanda',
    'Antigua and Barbuda': 'America/Antigua',
    'Argentina': 'America/Argentina/Buenos_Aires',
    'Armenia': 'Asia/Yerevan',
    'Austria': 'Europe/Vienna',
    'Azerbaijan': 'Asia/Baku',
    'Bahamas': 'America/Nassau',
    'Bahrain': 'Asia/Bahrain',
    'Bangladesh': 'Asia/Dhaka',
    'Barbados': 'America/Barbados',
    'Belarus': 'Europe/Minsk',
    'Belgium': 'Europe/Brussels',
    'Belize': 'America/Belize',
    'Benin': 'Africa/Porto-Novo',
    'Bhutan': 'Asia/Thimphu',
    'Bolivia': 'America/La_Paz',
    'Bosnia and Herzegovina': 'Europe/Sarajevo',
    'Botswana': 'Africa/Gaborone',
    'Brunei': 'Asia/Brunei',
    'Bulgaria': 'Europe/Sofia',
    'Burkina Faso': 'Africa/Ouagadougou',
    'Burundi': 'Africa/Bujumbura',
    'Cabo Verde': 'Atlantic/Cape_Verde',
    'Cambodia': 'Asia/Phnom_Penh',
    'Cameroon': 'Africa/Douala',
    'Central African Republic': 'Africa/Bangui',
    'Chad': 'Africa/Ndjamena',
    'Chile': 'America/Santiago',
    'Colombia': 'America/Bogota',
    'Comoros': 'Indian/Comoro',
    'Costa Rica': 'America/Costa_Rica',
    "Cote d'Ivoire": 'Africa/Abidjan',
    'Croatia': 'Europe/Zagreb',
    'Cuba': 'America/Havana',
    'Cyprus': 'Asia/Nicosia',
    'Czech Republic': 'Europe/Prague',
    'Denmark': 'Europe/Copenhagen',
    'Djibouti': 'Africa/Djibouti',
    'Dominica': 'America/Dominica',
    'Dominican Republic': 'America/Santo_Domingo',
    'Egypt': 'Africa/Cairo',
    'El Salvador': 'America/El_Salvador',
    'Equatorial Guinea': 'Africa/Malabo',
    'Eritrea': 'Africa/Asmara',
    'Estonia': 'Europe/Tallinn',
    'Eswatini': 'Africa/Mbabane',
    'Ethiopia': 'Africa/Addis_Ababa',
    'Fiji': 'Pacific/Fiji',
    'Finland': 'Europe/Helsinki',
    'Gabon': 'Africa/Libreville',
    'Gambia': 'Africa/Banjul',
    'Georgia': 'Asia/Tbilisi',
    'Germany': 'Europe/Berlin',
    'Ghana': 'Africa/Accra',
    'Greece': 'Europe/Athens',
    'Grenada': 'America/Grenada',
    'Guatemala': 'America/Guatemala',
    'Guinea': 'Africa/Conakry',
    'Guinea-Bissau': 'Africa/Bissau',
    'Guyana': 'America/Guyana',
    'Haiti': 'America/Port-au-Prince',
    'Honduras': 'America/Tegucigalpa',
    'Hungary': 'Europe/Budapest',
    'Iceland': 'Atlantic/Reykjavik',
    'India': 'Asia/Kolkata',
    'Iran': 'Asia/Tehran',
    'Iraq': 'Asia/Baghdad',
    'Ireland': 'Europe/Dublin',
    'Israel': 'Asia/Jerusalem',
    'Italy': 'Europe/Rome',
    'Hong Kong': 'Asia/Hong_Kong',
    'Jamaica': 'America/Jamaica',
    'Japan': 'Asia/Tokyo',
    'Jordan': 'Asia/Amman',
    'Kenya': 'Africa/Nairobi',
    'Kuwait': 'Asia/Kuwait',
    'Kyrgyzstan': 'Asia/Bishkek',
    'Laos': 'Asia/Vientiane',
    'Latvia': 'Europe/Riga',
    'Lebanon': 'Asia/Beirut',
    'Lesotho': 'Africa/Maseru',
    'Liberia': 'Africa/Monrovia',
    'Libya': 'Africa/Tripoli',
    'Liechtenstein': 'Europe/Vaduz',
    'Lithuania': 'Europe/Vilnius',
    'Luxembourg': 'Europe/Luxembourg',
    'Madagascar': 'Indian/Antananarivo',
    'Malawi': 'Africa/Blantyre',
    'Malaysia': 'Asia/Kuala_Lumpur',
    'Maldives': 'Indian/Maldives',
    'Mali': 'Africa/Bamako',
    'Malta': 'Europe/Malta',
    'Marshall Islands': 'Pacific/Majuro',
    'Mauritania': 'Africa/Nouakchott',
    'Mauritius': 'Indian/Mauritius',
    'Moldova': 'Europe/Chisinau',
    'Monaco': 'Europe/Monaco',
    'Morocco': 'Africa/Casablanca',
    'Mozambique': 'Africa/Maputo',
    'Myanmar': 'Asia/Yangon',
    'Namibia': 'Africa/Windhoek',
    'Nauru': 'Pacific/Nauru',
    'Nepal': 'Asia/Kathmandu',
    'Netherlands': 'Europe/Amsterdam',
    'New Zealand': 'Pacific/Auckland',
    'Nicaragua': 'America/Managua',
    'Niger': 'Africa/Niamey',
    'Nigeria': 'Africa/Lagos',
    'North Korea': 'Asia/Pyongyang',
    'North Macedonia': 'Europe/Skopje',
    'Norway': 'Europe/Oslo',
    'Oman': 'Asia/Muscat',
    'Pakistan': 'Asia/Karachi',
    'Palau': 'Pacific/Palau',
    'Palestine': 'Asia/Gaza',
    'Panama': 'America/Panama',
    'Paraguay': 'America/Asuncion',
    'Peru': 'America/Lima',
    'Philippines': 'Asia/Manila',
    'Poland': 'Europe/Warsaw',
    'Qatar': 'Asia/Qatar',
    'Romania': 'Europe/Bucharest',
    'Rwanda': 'Africa/Kigali',
    'Saint Kitts and Nevis': 'America/St_Kitts',
    'Saint Lucia': 'America/St_Lucia',
    'Saint Vincent and the Grenadines': 'America/St_Vincent',
    'Samoa': 'Pacific/Apia',
    'San Marino': 'Europe/San_Marino',
    'Sao Tome and Principe': 'Africa/Sao_Tome',
    'Saudi Arabia': 'Asia/Riyadh',
    'Senegal': 'Africa/Dakar',
    'Serbia': 'Europe/Belgrade',
    'Seychelles': 'Indian/Mahe',
    'Sierra Leone': 'Africa/Freetown',
    'Singapore': 'Asia/Singapore',
    'Slovakia': 'Europe/Bratislava',
    'Slovenia': 'Europe/Ljubljana',
    'Solomon Islands': 'Pacific/Guadalcanal',
    'Somalia': 'Africa/Mogadishu',
    'South Africa': 'Africa/Johannesburg',
    'South Korea': 'Asia/Seoul',
    'South Sudan': 'Africa/Juba',
    'Sri Lanka': 'Asia/Colombo',
    'Sudan': 'Africa/Khartoum',
    'Suriname': 'America/Paramaribo',
    'Sweden': 'Europe/Stockholm',
    'Switzerland': 'Europe/Zurich',
    'Syria': 'Asia/Damascus',
    'Tajikistan': 'Asia/Dushanbe',
    'Tanzania': 'Africa/Dar_es_Salaam',
    'Thailand': 'Asia/Bangkok',
    'Timor-Leste': 'Asia/Dili',
    'Togo': 'Africa/Lome',
    'Tonga': 'Pacific/Tongatapu',
    'Trinidad and Tobago': 'America/Port_of_Spain',
    'Tunisia': 'Africa/Tunis',
    'Turkey': 'Europe/Istanbul',
    'Turkmenistan': 'Asia/Ashgabat',
    'Tuvalu': 'Pacific/Funafuti',
    'Uganda': 'Africa/Kampala',
    'Ukraine': 'Europe/Kyiv',
    'United Arab Emirates': 'Asia/Dubai',
    'Uruguay': 'America/Montevideo',
    'Uzbekistan': 'Asia/Tashkent',
    'Vanuatu': 'Pacific/Efate',
    'Vatican City': 'Europe/Vatican',
    'Venezuela': 'America/Caracas',
    'Vietnam': 'Asia/Ho_Chi_Minh',
    'Yemen': 'Asia/Aden',
    'Zambia': 'Africa/Lusaka',
    'Zimbabwe': 'Africa/Harare'
  };

  const getCityTimeZone = (country, city) => {
    if (!country || !city) return null;

    if (country === 'Indonesia') {
      if (city.includes('jakarta')) return 'Asia/Jakarta';
      if (city.includes('bandung')) return 'Asia/Jakarta';
      if (city.includes('surabaya')) return 'Asia/Jakarta';
      if (city.includes('medan')) return 'Asia/Jakarta';
      if (city.includes('yogyakarta')) return 'Asia/Jakarta';
      if (city.includes('bali') || city.includes('denpasar')) return 'Asia/Makassar';
      if (city.includes('makassar')) return 'Asia/Makassar';
      if (city.includes('manado')) return 'Asia/Makassar';
      if (city.includes('jayapura') || city.includes('papua')) return 'Asia/Jayapura';
    }

    if (country === 'United States' || country === 'United States of America') {
      if (city.includes('new york') || city.includes('washington') || city.includes('boston') || city.includes('miami')) return 'America/New_York';
      if (city.includes('chicago') || city.includes('dallas') || city.includes('houston')) return 'America/Chicago';
      if (city.includes('denver') || city.includes('salt lake') || city.includes('phoenix')) return 'America/Denver';
      if (city.includes('los angeles') || city.includes('san francisco') || city.includes('seattle') || city.includes('las vegas')) return 'America/Los_Angeles';
      return 'America/New_York';
    }

    if (country === 'Canada') {
      if (city.includes('toronto') || city.includes('ottawa') || city.includes('montreal')) return 'America/Toronto';
      if (city.includes('vancouver') || city.includes('victoria')) return 'America/Vancouver';
      if (city.includes('calgary') || city.includes('edmonton')) return 'America/Edmonton';
      if (city.includes('winnipeg')) return 'America/Winnipeg';
      if (city.includes('halifax')) return 'America/Halifax';
      if (city.includes('st. john') || city.includes('st john')) return 'America/St_Johns';
      return 'America/Toronto';
    }

    if (country === 'Australia') {
      if (city.includes('sydney') || city.includes('melbourne') || city.includes('canberra')) return 'Australia/Sydney';
      if (city.includes('brisbane')) return 'Australia/Brisbane';
      if (city.includes('adelaide')) return 'Australia/Adelaide';
      if (city.includes('perth')) return 'Australia/Perth';
      if (city.includes('hobart')) return 'Australia/Hobart';
      if (city.includes('darwin')) return 'Australia/Darwin';
      return 'Australia/Sydney';
    }

    if (country === 'Mexico') {
      if (city.includes('tijuana')) return 'America/Tijuana';
      if (city.includes('cancun') || city.includes('merida')) return 'America/Cancun';
      return 'America/Mexico_City';
    }

    if (country === 'Brazil') {
      if (city.includes('manaus')) return 'America/Manaus';
      return 'America/Sao_Paulo';
    }

    if (country === 'Russia') {
      if (city.includes('moscow')) return 'Europe/Moscow';
      if (city.includes('yekaterinburg')) return 'Asia/Yekaterinburg';
      if (city.includes('novosibirsk')) return 'Asia/Novosibirsk';
      if (city.includes('vladivostok')) return 'Asia/Vladivostok';
      return 'Europe/Moscow';
    }

    return null;
  };

  const getUserTimeZone = () => {
    const country = userCountryName;
    if (!country) {
      const tz = userTimeZoneHint || GST_TIMEZONE;
      return { timeZone: tz, label: userTimeZoneHint ? 'User Timezone' : 'Unknown Timezone' };
    }

    if (multiTimeZoneCountries.has(country)) {
      const cityTz = getCityTimeZone(country, userCityName);
      if (cityTz) {
        return { timeZone: cityTz, label: `${country} Time` };
      }
      const tz = userTimeZoneHint || GST_TIMEZONE;
      return { timeZone: tz, label: userTimeZoneHint ? `${country} Time` : 'Unknown Timezone' };
    }

    const tz = countryToTimeZone[country];
    if (tz) {
      return { timeZone: tz, label: `${country} Time` };
    }

    const fallbackTz = userTimeZoneHint || GST_TIMEZONE;
    return { timeZone: fallbackTz, label: userTimeZoneHint ? 'User Timezone' : 'Unknown Timezone' };
  };

  const getTimePartsInTimeZone = (date, timeZone) => {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone,
      weekday: 'long',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    }).formatToParts(date);

    const map = {};
    parts.forEach((p) => {
      map[p.type] = p.value;
    });

    return {
      weekday: map.weekday,
      year: parseInt(map.year, 10),
      month: parseInt(map.month, 10),
      day: parseInt(map.day, 10),
      hour: map.hour,
      minute: map.minute
    };
  };

  const getOffsetMinutes = (timeZone, date) => {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone,
      timeZoneName: 'shortOffset'
    }).formatToParts(date);
    const tzPart = parts.find((p) => p.type === 'timeZoneName')?.value || 'GMT';
    const match = tzPart.match(/GMT([+-]\d{1,2})(?::(\d{2}))?/);
    if (!match) return 0;
    const hours = parseInt(match[1], 10);
    const minutes = match[2] ? parseInt(match[2], 10) : 0;
    return hours * 60 + Math.sign(hours) * minutes;
  };

  const makeUtcFromZonedTime = (year, month, day, timeStr, timeZone) => {
    const [h, m] = (timeStr || '00:00').split(':').map(Number);
    const utcGuess = Date.UTC(year, month - 1, day, h, m, 0);
    const offsetMinutes = getOffsetMinutes(timeZone, new Date(utcGuess));
    return new Date(utcGuess - offsetMinutes * 60000);
  };

  const formatLocalTimeFromAest = (timeStr, userTimeZone) => {
    if (!timeStr) return '';
    const aestParts = getTimePartsInTimeZone(new Date(), GST_TIMEZONE);
    const localDate = makeUtcFromZonedTime(
      aestParts.year,
      aestParts.month,
      aestParts.day,
      timeStr,
      GST_TIMEZONE
    );
    return new Intl.DateTimeFormat('en-US', {
      timeZone: userTimeZone,
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    }).format(localDate);
  };

  const getDayShiftLabel = (timeStr, userTimeZone) => {
    if (!timeStr) return '';
    const aestParts = getTimePartsInTimeZone(new Date(), GST_TIMEZONE);
    const localDate = makeUtcFromZonedTime(
      aestParts.year,
      aestParts.month,
      aestParts.day,
      timeStr,
      GST_TIMEZONE
    );
    const localParts = getTimePartsInTimeZone(localDate, userTimeZone);

    const aestKey = `${aestParts.year}-${String(aestParts.month).padStart(2, '0')}-${String(aestParts.day).padStart(2, '0')}`;
    const localKey = `${localParts.year}-${String(localParts.month).padStart(2, '0')}-${String(localParts.day).padStart(2, '0')}`;

    if (localKey < aestKey) return ' (prev day)';
    if (localKey > aestKey) return ' (next day)';
    return '';
  };

  // Get conditions for current wallet type
  const getCurrentConditions = () => {
    switch(withdrawalType) {
      case 'working': return withdrawalConditions.agPower || {};
      case 'roi': return withdrawalConditions.agRoi || {};
      case 'energy': return withdrawalConditions.agEnergy || {};
      default: return {};
    }
  };

  // Check withdrawal eligibility
  const checkWithdrawalEligibility = () => {
    // Check user withdrawal status
    if (userWithdrawalStatus === 'blocked') {
      setIsWithdrawalAllowed(false);
      setWithdrawalMessage('Your withdrawal has been blocked by admin. Please contact support.');
      return;
    }

    if (userWithdrawalStatus === 'paused') {
      setIsWithdrawalAllowed(false);
      setWithdrawalMessage('Your withdrawal is temporarily paused. Please contact support.');
      return;
    }

    // Check daily limit
    if (dailyWithdrawalCount >= maxDailyWithdrawals) {
      setIsWithdrawalAllowed(false);
      setWithdrawalMessage(`Daily withdrawal limit reached (${maxDailyWithdrawals} per day)`);
      return;
    }

    // Check minimum amount
    const minAmount = withdrawalConditions.minWithdrawal || 12;
    if (amount && parseFloat(amount) < minAmount) {
      setIsWithdrawalAllowed(false);
      setWithdrawalMessage(`Minimum withdrawal is $${minAmount}`);
      return;
    }

    // Check balance
    if (amount && parseFloat(amount) > getAvailableBalance()) {
      setIsWithdrawalAllowed(false);
      setWithdrawalMessage('Insufficient balance');
      return;
    }

    const conditions = getCurrentConditions();
    const slot1Enabled = conditions?.slot1Enabled ?? true;
    const slot2Enabled = conditions?.slot2Enabled ?? true;
    const hasAnySlotEnabled = slot1Enabled || slot2Enabled;
    const days = conditions?.days || [];

    if (!hasAnySlotEnabled) {
      setIsWithdrawalAllowed(false);
      setWithdrawalMessage('Withdrawal time slots are disabled by admin.');
      return;
    }

    // Check day restrictions only (ignore time restrictions)
    if (days.length > 0 && !days.includes('Everyday')) {
      const now = new Date();
      const { timeZone: userTimeZone } = getUserTimeZone();
      const userNow = getTimePartsInTimeZone(now, userTimeZone);
      const currentDay = userNow.weekday;
      if (!days.includes(currentDay)) {
        setIsWithdrawalAllowed(false);
        setWithdrawalMessage(`Only allowed on: ${days.join(', ')}`);
        return;
      }
    }

    setIsWithdrawalAllowed(true);
    setWithdrawalMessage('');
  };

  // Check time slot
  const checkTimeSlot = (conditions, currentTime) => {
    const slot1Enabled = conditions.slot1Enabled ?? true;
    const slot2Enabled = conditions.slot2Enabled ?? true;

    if (!slot1Enabled && !slot2Enabled) return true;

    const current = convertToMinutes(currentTime);
    if (slot1Enabled && conditions.startTime1 && conditions.endTime1) {
      const start1 = convertToMinutes(conditions.startTime1);
      const end1 = convertToMinutes(conditions.endTime1);
      if (current >= start1 && current <= end1) return true;
    }

    if (slot2Enabled && conditions.startTime2 && conditions.endTime2) {
      const start2 = convertToMinutes(conditions.startTime2);
      const end2 = convertToMinutes(conditions.endTime2);
      if (current >= start2 && current <= end2) return true;
    }

    return false;
  };

  // Convert time to minutes
  const convertToMinutes = (time) => {
    if (!time) return 0;
    const [hours, minutes] = time.split(':').map(Number);
    return hours * 60 + minutes;
  };

  // Format time display
  const formatTimeDisplay = (conditions) => {
    const { timeZone } = getUserTimeZone();
    const ranges = [];

    if (conditions.startTime1 && conditions.endTime1) {
      ranges.push(
        `${formatLocalTimeFromAest(conditions.startTime1, timeZone)} - ${formatLocalTimeFromAest(conditions.endTime1, timeZone)}${getDayShiftLabel(conditions.startTime1, timeZone)}`
      );
    }

    if (conditions.startTime2 && conditions.endTime2) {
      ranges.push(
        `${formatLocalTimeFromAest(conditions.startTime2, timeZone)} - ${formatLocalTimeFromAest(conditions.endTime2, timeZone)}${getDayShiftLabel(conditions.startTime2, timeZone)}`
      );
    }

    if (ranges.length === 0) return 'All day';
    return ranges.join(', ');
  };

  // Re-check eligibility
  useEffect(() => {
    checkWithdrawalEligibility();
  }, [userWithdrawalStatus, dailyWithdrawalCount, amount, withdrawalType, withdrawalConditions]);

  // Handle cryptocurrency selection
  const handleCryptoSelect = (crypto) => {
    setSelectedCrypto(crypto);
    setCryptoAddress(usedCurrenciesData[crypto]?.address || '');
  };

  // Handle withdrawal
  const handleWithdrawal = async (e) => {
    e.preventDefault();

    // Check eligibility
    if (!isWithdrawalAllowed) {
      showDialog('error', 'Not Allowed', withdrawalMessage);
      return;
    }

    const minAmount = withdrawalConditions.minWithdrawal || 12;
    if (!amount || parseFloat(amount) < minAmount) {
      showDialog('error', 'Invalid Amount', `Minimum: $${minAmount}`);
      return;
    }

    if (parseFloat(amount) > getAvailableBalance()) {
      showDialog('error', 'Insufficient Balance', 'Not enough balance');
      return;
    }

    if (!selectedCrypto || !cryptoAddress.trim()) {
      showDialog('error', 'Missing Info', 'Select crypto and enter address');
      return;
    }

    setLoading(true);
    
    try {
      const withdrawalId = `WDR${Date.now()}`;
      const today = getTodayDate();
      
      const feeAmount = (parseFloat(amount) * withdrawalFee) / 100;
      const netAmount = parseFloat(amount) - feeAmount;

      const withdrawalData = {
        id: withdrawalId,
        userId,
        userDbKey,
        userName: localStorage.getItem('userName') || 'User',
        amount: parseFloat(amount),
        netAmount,
        feeAmount,
        withdrawalFee,
        walletType: withdrawalType === 'working' ? 'AV Power Wallet' : withdrawalType === 'roi' ? 'AV ROI Wallet' : 'AV Energy Wallet',
        requestDate: new Date().toISOString(),
        crypto: {
          currency: selectedCrypto,
          network: cryptoNetworks[selectedCrypto],
          address: cryptoAddress.trim()
        },
        date: today
      };

      // Save withdrawal in date-wise structure
      const withdrawalRef = ref(database, `withdrawals/${today}/${userId}/${withdrawalId}`);
      await set(withdrawalRef, withdrawalData);

      // Update wallet balance
      await updateWalletBalance(parseFloat(amount));

      // Save (or update) selected crypto address for future reuse
      await saveWithdrawalAddress(cryptoAddress.trim());

      // Update daily count
      setDailyWithdrawalCount(prev => prev + 1);

      // Show success
      showDialog('success', 'Success', 
        `Withdrawal Request Submitted!\n\n` +
        `Amount: $${amount}\n` +
        `Fee: ${withdrawalFee}% ($${feeAmount.toFixed(2)})\n` +
        `Net: $${netAmount.toFixed(2)}\n` +
        `Status: Pending\n\n` +
        `Please wait for admin approval.`
      );

      // Reset form
      setAmount('');
      
      // Refresh data
      fetchUserData(userDbKey, userRegistrationDate);

    } catch (error) {
      console.error('Withdrawal error:', error);
      showDialog('error', 'Error', 'Failed to process withdrawal');
    } finally {
      setLoading(false);
    }
  };

  // Update wallet balance
  const updateWalletBalance = async (amount) => {
    try {
      const userRef = ref(database, `users/${userRegistrationDate}/${userDbKey}`);
      const snapshot = await get(userRef);
      
      if (snapshot.exists()) {
        const userData = snapshot.val();
        const updates = {};
        
        let balanceField = '';
        switch(withdrawalType) {
          case 'working': balanceField = 'wallets/working'; break;
          case 'roi': balanceField = 'wallets/roi'; break;
          case 'energy': balanceField = 'wallets/energy'; break;
        }
        
        const currentBalance = parseFloat(userData.wallets?.[withdrawalType]) || 0;
        const newBalance = Math.max(0, currentBalance - amount);
        updates[balanceField] = newBalance;
        
        await update(userRef, updates);
        
        // Update local state
        switch(withdrawalType) {
          case 'working': setWorkingBalance(newBalance); break;
          case 'roi': setRoiBalance(newBalance); break;
          case 'energy': setEnergyBalance(newBalance); break;
        }
      }
    } catch (error) {
      console.error('Error updating wallet:', error);
      throw error;
    }
  };

  // Save withdrawal address
  const saveWithdrawalAddress = async (address) => {
    try {
      const userRef = ref(database, `users/${userRegistrationDate}/${userDbKey}`);
      const snapshot = await get(userRef);
      
      if (snapshot.exists()) {
        const userData = snapshot.val();
        const updates = {};
        
        const withdrawalAddress = userData.withdrawalAddress || {};
        withdrawalAddress[selectedCrypto] = {
          address: address,
          saved: true,
          savedAt: new Date().toISOString()
        };
        
        updates['withdrawalAddress'] = withdrawalAddress;
        await update(userRef, updates);
        
        setUsedCurrenciesData(prev => ({
          ...prev,
          [selectedCrypto]: withdrawalAddress[selectedCrypto]
        }));
      }
    } catch (error) {
      console.error('Error saving address:', error);
    }
  };

  // Copy to clipboard
  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      showDialog('success', 'Copied', 'Address copied!');
    });
  };

  // Helper functions
  const getAvailableBalance = () => {
    switch(withdrawalType) {
      case 'working': return workingBalance;
      case 'roi': return roiBalance;
      case 'energy': return energyBalance;
      default: return 0;
    }
  };

  const formatBalance = (value) => `$${parseFloat(value || 0).toFixed(2)}`;

  const usedCurrencies = Object.keys(usedCurrenciesData);
  const isSavedAddressSelected = Boolean(
    selectedCrypto &&
    usedCurrenciesData[selectedCrypto]?.address &&
    cryptoAddress === usedCurrenciesData[selectedCrypto]?.address
  );
  const hasWithdrawnToday = dailyWithdrawalCount >= maxDailyWithdrawals;
  const today = getTodayDate();
  const minWithdrawal = withdrawalConditions.minWithdrawal || 12;
  const disableReasons = [];
  if (loading) disableReasons.push('Processing');
  if (!amount) disableReasons.push('Enter amount');
  if (!selectedCrypto) disableReasons.push('Select crypto');
  if (!cryptoAddress) disableReasons.push('Enter address');
  if (!isWithdrawalAllowed) disableReasons.push('Not allowed by rules');
  const isSubmitDisabled = loading || !amount || !selectedCrypto || !cryptoAddress || !isWithdrawalAllowed;
  const { label: userTimeZoneLabel } = getUserTimeZone();
  
  // Get current conditions for display
  const currentConditions = getCurrentConditions();

  return (
    <div className="max-w-4xl mx-auto px-4 pt-16 pb-8">
      {/* Dialog */}
      <Dialog
        isOpen={dialog.isOpen}
        onClose={closeDialog}
        title={dialog.title}
        message={dialog.message}
        type={dialog.type}
      />

      {/* Header */}
      <div className="mb-4">
        <h1 className="text-lg font-semibold text-foreground">Crypto Withdrawal</h1>
        <p className="text-sm text-muted-foreground mt-0.5">Withdraw funds from your wallets</p>
      </div>

      {/* User Status Banner */}
      {userWithdrawalStatus !== 'active' && (
        <div className={`mb-4 p-3.5 rounded-xl border ${
          userWithdrawalStatus === 'blocked' 
            ? 'bg-red-500/10 border-red-500/30' 
            : 'bg-yellow-500/10 border-yellow-500/30'
        }`}>
          <div className="flex items-start gap-2.5">
            <Shield className={
              userWithdrawalStatus === 'blocked' ? 'text-red-400' : 'text-yellow-400'
            } size={18} />
            <div>
              <p className="text-sm font-medium text-foreground">
                Withdrawal {userWithdrawalStatus.charAt(0).toUpperCase() + userWithdrawalStatus.slice(1)}
              </p>
              <p className="text-xs text-muted-foreground mt-1">
                {userWithdrawalStatus === 'blocked'
                  ? 'Your withdrawal has been blocked by admin. Please contact support.'
                  : 'Your withdrawal is temporarily paused. Please contact support.'}
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Daily Limit Card */}
      <div className="bg-card rounded-xl p-3.5 mb-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-xs text-muted-foreground">Daily Withdrawals</p>
            <p className={`text-base font-semibold ${hasWithdrawnToday ? 'text-red-400' : 'text-foreground'}`}>
              {dailyWithdrawalCount} / {maxDailyWithdrawals}
            </p>
          </div>
          <div className="text-right">
            <p className="text-xs text-muted-foreground">Today</p>
            <p className="text-sm text-foreground">{today}</p>
          </div>
        </div>
        {hasWithdrawnToday && (
          <p className="text-red-400 text-xs mt-2">
            Daily limit reached. Try again tomorrow.
          </p>
        )}
      </div>

      {/* Package Fee Card */}
      {highestPackage && (
        <div className="bg-purple-500/10 border border-purple-500/30 rounded-xl p-3.5 mb-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2.5">
              <Package className="text-purple-400" size={18} />
              <div>
                <p className="text-xs text-purple-200">Based on Highest Package</p>
                <p className="text-sm text-foreground font-medium">
                  {highestPackage.packageName || 'Package'} - {withdrawalFee}% Fee
                </p>
              </div>
            </div>
            <div className="text-sm text-purple-300 font-semibold">
              ${parseFloat(highestPackage.totalAmount || highestPackage.amount || 0).toFixed(2)}
            </div>
          </div>
        </div>
      )}

      {/* Wallet Selection */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-2.5 mb-4">
        {[
          { type: 'working', name: 'AV Power Wallet', balance: workingBalance, icon: walletIcons.working },
          { type: 'roi', name: 'AV ROI Wallet', balance: roiBalance, icon: walletIcons.roi },
          { type: 'energy', name: 'AV Energy Wallet', balance: energyBalance, icon: walletIcons.energy }
        ].map((wallet) => (
          <button
            key={wallet.type}
            onClick={() => setWithdrawalType(wallet.type)}
            disabled={hasWithdrawnToday || userWithdrawalStatus !== 'active'}
            className={`p-3 border rounded-lg text-left transition-all ${
              hasWithdrawnToday || userWithdrawalStatus !== 'active'
                ? 'opacity-50 cursor-not-allowed border-border'
                : withdrawalType === wallet.type
                ? 'border-primary bg-primary/10'
                : 'border-border hover:border-muted'
            }`}
          >
            <div className="flex justify-between items-center">
              <div className="flex items-center gap-2">
                {wallet.icon}
                <div>
                  <p className="text-xs text-muted-foreground">{wallet.name}</p>
                  <p className="text-sm text-foreground font-semibold">
                    {formatBalance(wallet.balance)}
                  </p>
                </div>
              </div>
              {withdrawalType === wallet.type && (
                <Check className="text-primary" size={14} />
              )}
            </div>
          </button>
        ))}
      </div>

      {/* Withdrawal Conditions */}
      {/* <div className="bg-card rounded-xl p-3.5 mb-4">
        <h3 className="text-sm text-foreground font-medium mb-2.5">Conditions for {withdrawalType === 'working' ? 'AV Power' : withdrawalType === 'roi' ? 'AV ROI' : 'AV Energy'} Wallet</h3>
        <div className="grid grid-cols-2 gap-2.5 text-xs">
          <div className="flex items-center gap-1.5 text-muted-foreground">
            <CreditCard size={12} />
            <span>Min: ${minWithdrawal}</span>
          </div>
          <div className="flex items-center gap-1.5 text-muted-foreground">
            <Calendar size={12} />
            <span>Days: {currentConditions.days?.join(', ') || 'Everyday'}</span>
          </div>
          <div className="flex items-center gap-1.5 text-muted-foreground col-span-2">
            <Clock size={12} />
            <span>Time ({userTimeZoneLabel}): {formatTimeDisplay(currentConditions)}</span>
          </div>
          <div className="flex items-center gap-1.5 text-muted-foreground">
            <Wallet size={12} />
            <span>Fee: {withdrawalFee}%</span>
          </div>
        </div>
      </div> */}

      {/* Withdrawal Form */}
      {userWithdrawalStatus === 'active' && !hasWithdrawnToday && (
        <div className="bg-card rounded-xl p-4">
          <form onSubmit={handleWithdrawal} className="space-y-4">
            {/* Amount */}
            <div>
              <label className="block text-sm text-foreground mb-1.5">Amount (USD)</label>
              <div className="relative">
                <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-xs text-muted-foreground">$</span>
                <input
                  type="number"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  placeholder={`Min: $${minWithdrawal}`}
                  min={minWithdrawal}
                  step="0.01"
                  className="w-full pl-7 pr-3 py-2 bg-background border border-border rounded-lg text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:border-primary"
                  required
                />
              </div>
              <p className="text-xs text-muted-foreground mt-1">
                Available: {formatBalance(getAvailableBalance())}
              </p>
            </div>

            {/* Cryptocurrency Selection */}
            <div>
              <label className="block text-sm text-foreground mb-1.5">Select Cryptocurrency</label>
              <div className="grid grid-cols-1 gap-2">
                {availableCurrencies.map((crypto) => (
                  <button
                    key={crypto}
                    type="button"
                    onClick={() => handleCryptoSelect(crypto)}
                    className={`p-3 border rounded-lg text-left ${
                      selectedCrypto === crypto
                        ? 'border-primary bg-primary/10'
                        : 'border-border hover:border-muted'
                    }`}
                  >
                    <div className="flex justify-between items-center">
                      <div>
                        <p className="text-sm text-foreground font-medium">{crypto}</p>
                        <p className="text-xs text-muted-foreground">{cryptoNetworks[crypto]}</p>
                      </div>
                      {usedCurrencies.includes(crypto) && (
                        <Lock size={12} className="text-yellow-400" />
                      )}
                    </div>
                  </button>
                ))}
              </div>
            </div>

            {/* Address Input */}
            {selectedCrypto && (
              <div>
                <label className="block text-sm text-foreground mb-1.5">{selectedCrypto} Address</label>
                <div className="relative">
                  <input
                    type="text"
                    value={cryptoAddress}
                    onChange={(e) => {
                      if (!isSavedAddressSelected) {
                        setCryptoAddress(e.target.value);
                      }
                    }}
                    readOnly={isSavedAddressSelected}
                    placeholder={`Enter ${selectedCrypto} address`}
                    className={`w-full pl-3 pr-8 py-2 bg-background border border-border rounded-lg text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:border-primary ${
                      isSavedAddressSelected ? 'opacity-70 cursor-not-allowed' : ''
                    }`}
                    required
                  />
                  {cryptoAddress && (
                    <button
                      type="button"
                      onClick={() => copyToClipboard(cryptoAddress)}
                      className="absolute right-2 top-1/2 transform -translate-y-1/2 text-muted-foreground hover:text-foreground"
                    >
                      <Copy size={14} />
                    </button>
                  )}
                </div>
              </div>
            )}

            {/* Fee Calculation */}
            {amount && parseFloat(amount) >= minWithdrawal && (
              <div className="bg-background border border-border rounded-lg p-3">
                <div className="grid grid-cols-3 gap-2 text-center">
                  <div>
                    <p className="text-xs text-muted-foreground">Amount</p>
                    <p className="text-sm text-foreground font-semibold">${parseFloat(amount).toFixed(2)}</p>
                  </div>
                  <div>
                    <p className="text-xs text-muted-foreground">Fee ({withdrawalFee}%)</p>
                    <p className="text-sm text-red-400 font-semibold">
                      ${((parseFloat(amount) * withdrawalFee) / 100).toFixed(2)}
                    </p>
                  </div>
                  <div>
                    <p className="text-xs text-muted-foreground">You Receive</p>
                    <p className="text-sm text-green-400 font-semibold">
                      ${(parseFloat(amount) - (parseFloat(amount) * withdrawalFee) / 100).toFixed(2)}
                    </p>
                  </div>
                </div>
              </div>
            )}

            {/* Submit Button */}
            <button
              type="submit"
              disabled={isSubmitDisabled}
              className={`w-full py-2.5 text-sm font-medium rounded-lg transition-all ${
                isSubmitDisabled
                  ? 'bg-muted cursor-not-allowed text-muted-foreground'
                  : 'bg-primary hover:bg-primary/90 text-primary-foreground'
              }`}
            >
              {loading ? (
                <div className="flex items-center justify-center gap-2">
                  <Loader2 className="animate-spin" size={16} />
                  Processing...
                </div>
              ) : (
                <div className="flex items-center justify-center gap-2">
                  <Send size={16} />
                  Submit Withdrawal
                </div>
              )}
            </button>

            {/* Error Message */}
            {!isWithdrawalAllowed && (
              <div className="p-3 bg-red-500/10 border border-red-500/30 rounded-lg">
                <p className="text-xs text-red-400">{withdrawalMessage}</p>
              </div>
            )}

            {isSubmitDisabled && disableReasons.length > 0 && (
              <div className="p-3 bg-background border border-border rounded-lg">
                <p className="text-xs text-muted-foreground">
                  Disabled because: {disableReasons.join(', ')}
                </p>
              </div>
            )}
          </form>
        </div>
      )}

      {/* Footer Info */}
      <div className="mt-4 text-center text-xs text-muted-foreground">
        <p>Daily limit: {maxDailyWithdrawals} withdrawal per day</p>
        <p className="mt-0.5">Withdrawal requests require admin approval</p>
      </div>
    </div>
  );
};

export default RequestWithdrawal;